!(function (e) {
  var t, i, o, n;
  e = jQuery = e;
  (t = window),
    (i = (function (e, t) {
      "use strict";
      if (t.getElementsByClassName) {
        var i,
          o,
          n = t.documentElement,
          s = e.Date,
          r = e.HTMLPictureElement,
          a = "addEventListener",
          l = "getAttribute",
          d = e[a],
          c = e.setTimeout,
          u = e.requestAnimationFrame || c,
          p = e.requestIdleCallback,
          h = /^picture$/i,
          f = ["load", "error", "lazyincluded", "_lazyloaded"],
          g = {},
          v = Array.prototype.forEach,
          m = function (e, t) {
            return (
              g[t] || (g[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
              g[t].test(e[l]("class") || "") && g[t]
            );
          },
          y = function (e, t) {
            m(e, t) ||
              e.setAttribute("class", (e[l]("class") || "").trim() + " " + t);
          },
          w = function (e, t) {
            var i;
            (i = m(e, t)) &&
              e.setAttribute("class", (e[l]("class") || "").replace(i, " "));
          },
          b = function (e, t, i) {
            var o = i ? a : "removeEventListener";
            i && b(e, t),
              f.forEach(function (i) {
                e[o](i, t);
              });
          },
          k = function (e, o, n, s, r) {
            var a = t.createEvent("CustomEvent");
            return (
              n || (n = {}),
              (n.instance = i),
              a.initCustomEvent(o, !s, !r, n),
              e.dispatchEvent(a),
              a
            );
          },
          S = function (t, i) {
            var n;
            !r && (n = e.picturefill || o.pf)
              ? n({ reevaluate: !0, elements: [t] })
              : i && i.src && (t.src = i.src);
          },
          T = function (e, t) {
            return (getComputedStyle(e, null) || {})[t];
          },
          z = function (e, t, i) {
            for (
              i = i || e.offsetWidth;
              i < o.minSize && t && !e._lazysizesWidth;

            )
              (i = t.offsetWidth), (t = t.parentNode);
            return i;
          },
          x = (function () {
            var e,
              i,
              o = [],
              n = [],
              s = o,
              r = function () {
                var t = s;
                for (s = o.length ? n : o, e = !0, i = !1; t.length; )
                  t.shift()();
                e = !1;
              },
              a = function (o, n) {
                e && !n
                  ? o.apply(this, arguments)
                  : (s.push(o), i || ((i = !0), (t.hidden ? c : u)(r)));
              };
            return (a._lsFlush = r), a;
          })(),
          C = function (e, t) {
            return t
              ? function () {
                  x(e);
                }
              : function () {
                  var t = this,
                    i = arguments;
                  x(function () {
                    e.apply(t, i);
                  });
                };
          },
          $ = function (e) {
            var t,
              i = 0,
              n = o.ricTimeout,
              r = function () {
                (t = !1), (i = s.now()), e();
              },
              a =
                p && o.ricTimeout
                  ? function () {
                      p(r, { timeout: n }),
                        n !== o.ricTimeout && (n = o.ricTimeout);
                    }
                  : C(function () {
                      c(r);
                    }, !0);
            return function (e) {
              var o;
              (e = !0 === e) && (n = 33),
                t ||
                  ((t = !0),
                  0 > (o = 125 - (s.now() - i)) && (o = 0),
                  e || (9 > o && p) ? a() : c(a, o));
            };
          },
          A = function (e) {
            var t,
              i,
              o = function () {
                (t = null), e();
              },
              n = function () {
                var e = s.now() - i;
                99 > e ? c(n, 99 - e) : (p || o)(o);
              };
            return function () {
              (i = s.now()), t || (t = c(n, 99));
            };
          };
        !(function () {
          var t,
            i = {
              lazyClass: "lazyload",
              loadedClass: "lazyloaded",
              loadingClass: "lazyloading",
              preloadClass: "lazypreload",
              errorClass: "lazyerror",
              autosizesClass: "lazyautosizes",
              srcAttr: "data-src",
              srcsetAttr: "data-srcset",
              sizesAttr: "data-sizes",
              minSize: 40,
              customMedia: {},
              init: !0,
              expFactor: 1.5,
              hFac: 0.8,
              loadMode: 2,
              loadHidden: !0,
              ricTimeout: 300,
            };
          for (t in ((o = e.lazySizesConfig || e.lazysizesConfig || {}), i))
            t in o || (o[t] = i[t]);
          (e.lazySizesConfig = o),
            c(function () {
              o.init && L();
            });
        })();
        var E = (function () {
            var r,
              u,
              p,
              f,
              g,
              z,
              E,
              L,
              O,
              M,
              H,
              j,
              I,
              N,
              _ = /^img$/i,
              W = /^iframe$/i,
              D = "onscroll" in e && !/glebot/.test(navigator.userAgent),
              R = 0,
              F = 0,
              q = -1,
              B = function (e) {
                F--,
                  e && e.target && b(e.target, B),
                  (!e || 0 > F || !e.target) && (F = 0);
              },
              U = function (e, i) {
                var o,
                  s = e,
                  r =
                    "hidden" == T(t.body, "visibility") ||
                    "hidden" != T(e, "visibility");
                for (
                  L -= i, H += i, O -= i, M += i;
                  r && (s = s.offsetParent) && s != t.body && s != n;

                )
                  (r = (T(s, "opacity") || 1) > 0) &&
                    "visible" != T(s, "overflow") &&
                    ((o = s.getBoundingClientRect()),
                    (r =
                      M > o.left &&
                      O < o.right &&
                      H > o.top - 1 &&
                      L < o.bottom + 1));
                return r;
              },
              X = function () {
                var e,
                  s,
                  a,
                  d,
                  c,
                  p,
                  h,
                  g,
                  v,
                  m = i.elements;
                if ((f = o.loadMode) && 8 > F && (e = m.length)) {
                  (s = 0),
                    q++,
                    null == I &&
                      ("expand" in o ||
                        (o.expand =
                          n.clientHeight > 500 && n.clientWidth > 500
                            ? 500
                            : 370),
                      (j = o.expand),
                      (I = j * o.expFactor)),
                    I > R && 1 > F && q > 2 && f > 2 && !t.hidden
                      ? ((R = I), (q = 0))
                      : (R = f > 1 && q > 1 && 6 > F ? j : 0);
                  for (; e > s; s++)
                    if (m[s] && !m[s]._lazyRace)
                      if (D)
                        if (
                          (((g = m[s][l]("data-expand")) && (p = 1 * g)) ||
                            (p = R),
                          v !== p &&
                            ((z = innerWidth + p * N),
                            (E = innerHeight + p),
                            (h = -1 * p),
                            (v = p)),
                          (a = m[s].getBoundingClientRect()),
                          (H = a.bottom) >= h &&
                            (L = a.top) <= E &&
                            (M = a.right) >= h * N &&
                            (O = a.left) <= z &&
                            (H || M || O || L) &&
                            (o.loadHidden ||
                              "hidden" != T(m[s], "visibility")) &&
                            ((u && 3 > F && !g && (3 > f || 4 > q)) ||
                              U(m[s], p)))
                        ) {
                          if ((J(m[s]), (c = !0), F > 9)) break;
                        } else
                          !c &&
                            u &&
                            !d &&
                            4 > F &&
                            4 > q &&
                            f > 2 &&
                            (r[0] || o.preloadAfterLoad) &&
                            (r[0] ||
                              (!g &&
                                (H ||
                                  M ||
                                  O ||
                                  L ||
                                  "auto" != m[s][l](o.sizesAttr)))) &&
                            (d = r[0] || m[s]);
                      else J(m[s]);
                  d && !c && J(d);
                }
              },
              Y = $(X),
              V = function (e) {
                y(e.target, o.loadedClass),
                  w(e.target, o.loadingClass),
                  b(e.target, K),
                  k(e.target, "lazyloaded");
              },
              Q = C(V),
              K = function (e) {
                Q({ target: e.target });
              },
              Z = function (e) {
                var t,
                  i = e[l](o.srcsetAttr);
                (t = o.customMedia[e[l]("data-media") || e[l]("media")]) &&
                  e.setAttribute("media", t),
                  i && e.setAttribute("srcset", i);
              },
              G = C(function (e, t, i, n, s) {
                var r, a, d, u, f, g;
                (f = k(e, "lazybeforeunveil", t)).defaultPrevented ||
                  (n &&
                    (i ? y(e, o.autosizesClass) : e.setAttribute("sizes", n)),
                  (a = e[l](o.srcsetAttr)),
                  (r = e[l](o.srcAttr)),
                  s &&
                    ((d = e.parentNode), (u = d && h.test(d.nodeName || ""))),
                  (g = t.firesLoad || ("src" in e && (a || r || u))),
                  (f = { target: e }),
                  g &&
                    (b(e, B, !0),
                    clearTimeout(p),
                    (p = c(B, 2500)),
                    y(e, o.loadingClass),
                    b(e, K, !0)),
                  u && v.call(d.getElementsByTagName("source"), Z),
                  a
                    ? e.setAttribute("srcset", a)
                    : r &&
                      !u &&
                      (W.test(e.nodeName)
                        ? (function (e, t) {
                            try {
                              e.contentWindow.location.replace(t);
                            } catch (i) {
                              e.src = t;
                            }
                          })(e, r)
                        : (e.src = r)),
                  s && (a || u) && S(e, { src: r })),
                  e._lazyRace && delete e._lazyRace,
                  w(e, o.lazyClass),
                  x(function () {
                    (!g || (e.complete && e.naturalWidth > 1)) &&
                      (g ? B(f) : F--, V(f));
                  }, !0);
              }),
              J = function (e) {
                var t,
                  i = _.test(e.nodeName),
                  n = i && (e[l](o.sizesAttr) || e[l]("sizes")),
                  s = "auto" == n;
                ((!s && u) ||
                  !i ||
                  (!e[l]("src") && !e.srcset) ||
                  e.complete ||
                  m(e, o.errorClass) ||
                  !m(e, o.lazyClass)) &&
                  ((t = k(e, "lazyunveilread").detail),
                  s && P.updateElem(e, !0, e.offsetWidth),
                  (e._lazyRace = !0),
                  F++,
                  G(e, t, s, n, i));
              },
              ee = function () {
                if (!u) {
                  if (s.now() - g < 999) return void c(ee, 999);
                  var e = A(function () {
                    (o.loadMode = 3), Y();
                  });
                  (u = !0),
                    (o.loadMode = 3),
                    Y(),
                    d(
                      "scroll",
                      function () {
                        3 == o.loadMode && (o.loadMode = 2), e();
                      },
                      !0,
                    );
                }
              };
            return {
              _: function () {
                (g = s.now()),
                  (i.elements = t.getElementsByClassName(o.lazyClass)),
                  (r = t.getElementsByClassName(
                    o.lazyClass + " " + o.preloadClass,
                  )),
                  (N = o.hFac),
                  d("scroll", Y, !0),
                  d("resize", Y, !0),
                  e.MutationObserver
                    ? new MutationObserver(Y).observe(n, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0,
                      })
                    : (n[a]("DOMNodeInserted", Y, !0),
                      n[a]("DOMAttrModified", Y, !0),
                      setInterval(Y, 999)),
                  d("hashchange", Y, !0),
                  [
                    "focus",
                    "mouseover",
                    "click",
                    "load",
                    "transitionend",
                    "animationend",
                    "webkitAnimationEnd",
                  ].forEach(function (e) {
                    t[a](e, Y, !0);
                  }),
                  /d$|^c/.test(t.readyState)
                    ? ee()
                    : (d("load", ee), t[a]("DOMContentLoaded", Y), c(ee, 2e4)),
                  i.elements.length ? (X(), x._lsFlush()) : Y();
              },
              checkElems: Y,
              unveil: J,
            };
          })(),
          P = (function () {
            var e,
              i = C(function (e, t, i, o) {
                var n, s, r;
                if (
                  ((e._lazysizesWidth = o),
                  (o += "px"),
                  e.setAttribute("sizes", o),
                  h.test(t.nodeName || ""))
                )
                  for (
                    n = t.getElementsByTagName("source"), s = 0, r = n.length;
                    r > s;
                    s++
                  )
                    n[s].setAttribute("sizes", o);
                i.detail.dataAttr || S(e, i.detail);
              }),
              n = function (e, t, o) {
                var n,
                  s = e.parentNode;
                s &&
                  ((o = z(e, s, o)),
                  (n = k(e, "lazybeforesizes", { width: o, dataAttr: !!t }))
                    .defaultPrevented ||
                    ((o = n.detail.width) &&
                      o !== e._lazysizesWidth &&
                      i(e, s, n, o)));
              },
              s = A(function () {
                var t,
                  i = e.length;
                if (i) for (t = 0; i > t; t++) n(e[t]);
              });
            return {
              _: function () {
                (e = t.getElementsByClassName(o.autosizesClass)),
                  d("resize", s);
              },
              checkElems: s,
              updateElem: n,
            };
          })(),
          L = function () {
            L.i || ((L.i = !0), P._(), E._());
          };
        return (i = {
          cfg: o,
          autoSizer: P,
          loader: E,
          init: L,
          uP: S,
          aC: y,
          rC: w,
          hC: m,
          fire: k,
          gW: z,
          rAF: x,
        });
      }
    })(t, t.document)),
    (t.lazySizes = i),
    "object" == typeof module && module.exports && (module.exports = i),
    (function (e, t) {
      var i = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
      };
      (t = t.bind(null, e, e.document)),
        "object" == typeof module && module.exports
          ? t(require("lazysizes"))
          : e.lazySizes
            ? i()
            : e.addEventListener("lazyunveilread", i, !0);
    })(window, function (e, t, i) {
      "use strict";
      function o(t, i) {
        var o,
          n,
          s,
          r,
          a = e.getComputedStyle(t);
        for (o in ((n = t.parentNode),
        (r = { isPicture: !(!n || !u.test(n.nodeName || "")) }),
        (s = function (e, i) {
          var o = t.getAttribute("data-" + e);
          if (!o) {
            var n = a.getPropertyValue("--ls-" + e);
            n && (o = n.trim());
          }
          if (o) {
            if ("true" == o) o = !0;
            else if ("false" == o) o = !1;
            else if (c.test(o)) o = parseFloat(o);
            else if ("function" == typeof l[e]) o = l[e](t, o);
            else if (g.test(o))
              try {
                o = JSON.parse(o);
              } catch (e) {}
            r[e] = o;
          } else
            e in l && "function" != typeof l[e]
              ? (r[e] = l[e])
              : i && "function" == typeof l[e] && (r[e] = l[e](t, o));
        }),
        l))
          s(o);
        return (
          i.replace(f, function (e, t) {
            t in r || s(t, !0);
          }),
          r
        );
      }
      function n(e, i, o) {
        var n = 0,
          s = 0,
          r = o;
        if (e) {
          if ("container" === i.ratio) {
            for (
              n = r.scrollWidth, s = r.scrollHeight;
              !((n && s) || r === t);

            )
              (n = (r = r.parentNode).scrollWidth), (s = r.scrollHeight);
            n && s && (i.ratio = s / n);
          }
          ((e = (function (e, t) {
            var i = [];
            return (
              (i.srcset = []),
              t.absUrl && (m.setAttribute("href", e), (e = m.href)),
              (e = ((t.prefix || "") + e + (t.postfix || "")).replace(
                f,
                function (e, i) {
                  return d[typeof t[i]] ? t[i] : e;
                },
              )),
              t.widths.forEach(function (o) {
                var n = t.widthmap[o] || o,
                  s = {
                    u: e
                      .replace(p, n)
                      .replace(h, t.ratio ? Math.round(o * t.ratio) : ""),
                    w: o,
                  };
                i.push(s), i.srcset.push((s.c = s.u + " " + o + "w"));
              }),
              i
            );
          })(e, i)).isPicture = i.isPicture),
            w && "IMG" == o.nodeName.toUpperCase()
              ? o.removeAttribute(a.srcsetAttr)
              : o.setAttribute(a.srcsetAttr, e.srcset.join(", ")),
            Object.defineProperty(o, "_lazyrias", { value: e, writable: !0 });
        }
      }
      function s(e, t) {
        var n = o(e, t);
        return (
          l.modifyOptions.call(e, { target: e, details: n, detail: n }),
          i.fire(e, "lazyriasmodifyoptions", n),
          n
        );
      }
      function r(e) {
        return (
          e.getAttribute(e.getAttribute("data-srcattr") || l.srcAttr) ||
          e.getAttribute(a.srcsetAttr) ||
          e.getAttribute(a.srcAttr) ||
          e.getAttribute("data-pfsrcset") ||
          ""
        );
      }
      var a,
        l,
        d = { string: 1, number: 1 },
        c = /^\-*\+*\d+\.*\d*$/,
        u = /^picture$/i,
        p = /\s*\{\s*width\s*\}\s*/i,
        h = /\s*\{\s*height\s*\}\s*/i,
        f = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
        g = /^\[.*\]|\{.*\}$/,
        v = /^(?:auto|\d+(px)?)$/,
        m = t.createElement("a"),
        y = t.createElement("img"),
        w = "srcset" in y && !("sizes" in y),
        b = !!e.HTMLPictureElement && !w;
      !(function () {
        var t,
          o = {
            prefix: "",
            postfix: "",
            srcAttr: "data-src",
            absUrl: !1,
            modifyOptions: function () {},
            widthmap: {},
            ratio: !1,
          };
        for (t in ((a = (i && i.cfg) || e.lazySizesConfig) ||
          ((a = {}), (e.lazySizesConfig = a)),
        a.supportsType ||
          (a.supportsType = function (e) {
            return !e;
          }),
        a.rias || (a.rias = {}),
        "widths" in (l = a.rias) ||
          ((l.widths = []),
          (function (e) {
            for (var t, i = 0; !t || 3e3 > t; )
              (i += 5) > 30 && (i += 1), (t = 36 * i), e.push(t);
          })(l.widths)),
        o))
          t in l || (l[t] = o[t]);
      })(),
        addEventListener(
          "lazybeforesizes",
          function (e) {
            var t, o, d, c, u, h, f, g, m, y, w, S, T;
            if (
              e.detail.instance == i &&
              ((t = e.target),
              e.detail.dataAttr &&
                !e.defaultPrevented &&
                !l.disabled &&
                (m = t.getAttribute(a.sizesAttr) || t.getAttribute("sizes")) &&
                v.test(m))
            ) {
              if (
                ((d = s(t, (o = r(t)))),
                (w = p.test(d.prefix) || p.test(d.postfix)),
                d.isPicture && (c = t.parentNode))
              )
                for (
                  h = 0, f = (u = c.getElementsByTagName("source")).length;
                  f > h;
                  h++
                )
                  (w || p.test((g = r(u[h])))) && (n(g, d, u[h]), (S = !0));
              w || p.test(o)
                ? (n(o, d, t), (S = !0))
                : S &&
                  (((T = []).srcset = []),
                  (T.isPicture = !0),
                  Object.defineProperty(t, "_lazyrias", {
                    value: T,
                    writable: !0,
                  })),
                S &&
                  (b
                    ? t.removeAttribute(a.srcAttr)
                    : "auto" != m &&
                      ((y = { width: parseInt(m, 10) }),
                      k({ target: t, detail: y })));
            }
          },
          !0,
        );
      var k = (function () {
        var o = function (e, t) {
            return e.w - t.w;
          },
          n = function (e, t) {
            var o;
            return (
              !e._lazyrias &&
                i.pWS &&
                (o = i.pWS(e.getAttribute(a.srcsetAttr || ""))).length &&
                (Object.defineProperty(e, "_lazyrias", {
                  value: o,
                  writable: !0,
                }),
                t &&
                  e.parentNode &&
                  (o.isPicture =
                    "PICTURE" == e.parentNode.nodeName.toUpperCase())),
              e._lazyrias
            );
          },
          s = function (t) {
            var o = e.devicePixelRatio || 1,
              n = i.getX && i.getX(t);
            return Math.min(n || o, 2.4, o);
          },
          r = function (t, i) {
            var r, a, l, d, c, u;
            if ((c = t._lazyrias).isPicture && e.matchMedia)
              for (
                a = 0,
                  l = (r = t.parentNode.getElementsByTagName("source")).length;
                l > a;
                a++
              )
                if (
                  n(r[a]) &&
                  !r[a].getAttribute("type") &&
                  (!(d = r[a].getAttribute("media")) ||
                    (matchMedia(d) || {}).matches)
                ) {
                  c = r[a]._lazyrias;
                  break;
                }
            return (
              (!c.w || c.w < i) &&
                ((c.w = i),
                (c.d = s(t)),
                (u = (function (e) {
                  for (var t, i, o = e.length, n = e[o - 1], s = 0; o > s; s++)
                    if ((((n = e[s]).d = n.w / e.w), n.d >= e.d)) {
                      !n.cached &&
                        (t = e[s - 1]) &&
                        t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
                        ((i = Math.pow(t.d - 0.6, 1.6)),
                        t.cached && (t.d += 0.15 * i),
                        t.d + (n.d - e.d) * i > e.d && (n = t));
                      break;
                    }
                  return n;
                })(c.sort(o)))),
              u
            );
          },
          l = function (o) {
            if (o.detail.instance == i) {
              var s,
                d = o.target;
              return !w && (e.respimage || e.picturefill || lazySizesConfig.pf)
                ? void t.removeEventListener("lazybeforesizes", l)
                : void (
                    ("_lazyrias" in d || (o.detail.dataAttr && n(d, !0))) &&
                    ((s = r(d, o.detail.width)),
                    s &&
                      s.u &&
                      d._lazyrias.cur != s.u &&
                      ((d._lazyrias.cur = s.u),
                      (s.cached = !0),
                      i.rAF(function () {
                        d.setAttribute(a.srcAttr, s.u),
                          d.setAttribute("src", s.u);
                      })))
                  );
            }
          };
        return (
          b ? (l = function () {}) : addEventListener("lazybeforesizes", l), l
        );
      })();
    }),
    (function (e, t, i) {
      "use strict";
      if (e.addEventListener) {
        var o,
          n = /^picture$/i,
          s = t.documentElement,
          r = (function () {
            var e,
              t = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g,
              i = function (t, i, o, n, s, r, a, l) {
                e.push({ c: i, u: o, w: 1 * ("w" == l ? a : n) });
              };
            return function (o) {
              return (e = []), o.replace(t, i), e;
            };
          })(),
          a = (function () {
            var e = function (e, t) {
                return e.w - t.w;
              },
              t = function (t, i) {
                var o = {
                    srcset: t.getAttribute(lazySizes.cfg.srcsetAttr) || "",
                  },
                  n = r(o.srcset);
                return (
                  Object.defineProperty(t, i, { value: o, writable: !0 }),
                  (o.cands = n),
                  (o.index = 0),
                  (o.dirty = !1),
                  n[0] && n[0].w
                    ? (n.sort(e), (o.cSrcset = [n[o.index].c]))
                    : ((o.cSrcset = o.srcset ? [o.srcset] : []),
                      (o.cands = [])),
                  o
                );
              };
            return function (e, i) {
              var o, s, r, a;
              if (
                !e[i] &&
                ((a = e.parentNode || {}),
                (e[i] = t(e, i)),
                (e[i].isImg = !0),
                n.test(a.nodeName || ""))
              )
                for (
                  e[i].picture = !0,
                    s = 0,
                    r = (o = a.getElementsByTagName("source")).length;
                  r > s;
                  s++
                )
                  t(o[s], i).isImg = !1;
              return e[i];
            };
          })(),
          l = {
            _lazyOptimumx: (function () {
              var e = function (e, t, i) {
                var o, n;
                return (
                  !e ||
                  !e.d ||
                  ((n = i > 0.7 ? 0.6 : 0.4),
                  !(e.d >= i) &&
                    (0.1 > (o = Math.pow(e.d - n, 1.6) || 0.1)
                      ? (o = 0.1)
                      : o > 3 && (o = 3),
                    i > e.d + (t - i) * o))
                );
              };
              return function (t, i, o) {
                var n, s;
                for (n = 0; n < t.cands.length; n++)
                  if (
                    (((s = t.cands[n]).d = (s.w || 1) / i), !(t.index >= n))
                  ) {
                    if (!(s.d <= o || e(t.cands[n - 1], s.d, o))) break;
                    t.cSrcset.push(s.c), (t.index = n);
                  }
              };
            })(),
          },
          d = (function () {
            var e = function (e, t, i, o, n) {
              var s,
                r = e[n];
              r &&
                ((s = r.index),
                l[n](r, t, i),
                (r.dirty && s == r.index) ||
                  (r.cSrcset.join(", "),
                  e.setAttribute(o, r.cSrcset.join(", ")),
                  (r.dirty = !0)));
            };
            return function (t, i, o, n, s) {
              var r,
                a,
                l,
                d,
                c = t[s];
              if (((c.width = i), c.picture && (a = t.parentNode)))
                for (
                  d = 0, l = (r = a.getElementsByTagName("source")).length;
                  l > d;
                  d++
                )
                  e(r[d], i, o, n, s);
              e(t, i, o, n, s);
            };
          })(),
          c = function (e) {
            var t =
              e.getAttribute("data-optimumx") || e.getAttribute("data-maxdpr");
            return (
              !t && o.constrainPixelDensity && (t = "auto"),
              t && (t = "auto" == t ? o.getOptimumX(e) : parseFloat(t, 10)),
              t
            );
          },
          u = function () {
            e.lazySizes &&
              !e.lazySizes.getOptimumX &&
              ((lazySizes.getX = c),
              (lazySizes.pWS = r),
              s.removeEventListener("lazybeforeunveil", u));
          };
        s.addEventListener("lazybeforeunveil", u),
          setTimeout(u),
          (o = (e.lazySizes && lazySizes.cfg) || e.lazySizesConfig) ||
            ((o = {}), (e.lazySizesConfig = o)),
          "function" != typeof o.getOptimumX &&
            (o.getOptimumX = function () {
              var t = e.devicePixelRatio || 1;
              return (
                t > 2.6 ? (t *= 0.6) : t > 1.9 ? (t *= 0.8) : (t -= 0.01),
                Math.min(Math.round(100 * t) / 100, 2)
              );
            }),
          e.devicePixelRatio &&
            addEventListener("lazybeforesizes", function (e) {
              var t,
                i,
                n,
                s,
                r = e.target,
                l = e.detail,
                u = l.dataAttr;
              e.defaultPrevented ||
                !(t = c(r)) ||
                t >= devicePixelRatio ||
                (!u ||
                  !r._lazyOptimumx ||
                  l.reloaded ||
                  (o.unloadedClass && lazySizes.hC(r, o.unloadedClass)) ||
                  (r._lazyOptimumx = null),
                (i = a(r, "_lazyOptimumx")),
                (n = l.width) &&
                  (i.width || 0) < n &&
                  ((s = u ? lazySizes.cfg.srcsetAttr : "srcset"),
                  lazySizes.rAF(function () {
                    d(r, n, t, s, "_lazyOptimumx");
                  })));
            });
      }
    })(window, document),
    (function (e, t) {
      var i = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
      };
      (t = t.bind(null, e, e.document)),
        "object" == typeof module && module.exports
          ? t(require("lazysizes"))
          : e.lazySizes
            ? i()
            : e.addEventListener("lazyunveilread", i, !0);
    })(window, function (e, t, i) {
      "use strict";
      var o, n;
      "srcset" in t.createElement("img") &&
        ((o = /^img$/i),
        (n = function (e) {
          (e.target.style.backgroundSize = ""),
            (e.target.style.backgroundImage = ""),
            e.target.removeEventListener(e.type, n);
        }),
        t.addEventListener(
          "lazybeforeunveil",
          function (e) {
            if (e.detail.instance == i) {
              var t = e.target;
              if (o.test(t.nodeName)) {
                var s = t.getAttribute("src");
                s &&
                  ((t.style.backgroundSize = "100% 100%"),
                  (t.style.backgroundImage = "url(" + s + ")"),
                  t.removeAttribute("src"),
                  t.addEventListener("load", n));
              }
            }
          },
          !1,
        ));
    }),
    (function (e, t) {
      var i = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
      };
      (t = t.bind(null, e, e.document)),
        "object" == typeof module && module.exports
          ? t(require("lazysizes"))
          : e.lazySizes
            ? i()
            : e.addEventListener("lazyunveilread", i, !0);
    })(window, function (e, t, i) {
      "use strict";
      if (e.addEventListener) {
        var o = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
          n = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
          s = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
          r = /^picture$/i,
          a = {
            getParent: function (t, i) {
              var o = t,
                n = t.parentNode;
              return (
                (i && "prev" != i) ||
                  !n ||
                  !r.test(n.nodeName || "") ||
                  (n = n.parentNode),
                "self" != i &&
                  (o =
                    "prev" == i
                      ? t.previousElementSibling
                      : (i &&
                          (n.closest || e.jQuery) &&
                          (n.closest
                            ? n.closest(i)
                            : jQuery(n).closest(i)[0])) ||
                        n),
                o
              );
            },
            getFit: function (e) {
              var t,
                i,
                o = (function (e) {
                  return getComputedStyle(e, null) || {};
                })(e),
                r = o.content || o.fontFamily,
                l = {
                  fit:
                    e._lazysizesParentFit || e.getAttribute("data-parent-fit"),
                };
              return (
                !l.fit && r && (t = r.match(n)) && (l.fit = t[1]),
                l.fit
                  ? (!(i =
                      e._lazysizesParentContainer ||
                      e.getAttribute("data-parent-container")) &&
                      r &&
                      (t = r.match(s)) &&
                      (i = t[1]),
                    (l.parent = a.getParent(e, i)))
                  : (l.fit = o.objectFit),
                l
              );
            },
            getImageRatio: function (t) {
              var i,
                n,
                s,
                a,
                l = t.parentNode,
                d =
                  l && r.test(l.nodeName || "")
                    ? l.querySelectorAll("source, img")
                    : [t];
              for (i = 0; i < d.length; i++)
                if (
                  ((n =
                    (t = d[i]).getAttribute(lazySizesConfig.srcsetAttr) ||
                    t.getAttribute("srcset") ||
                    t.getAttribute("data-pfsrcset") ||
                    t.getAttribute("data-risrcset") ||
                    ""),
                  (s = t._lsMedia || t.getAttribute("media")),
                  (s =
                    lazySizesConfig.customMedia[
                      t.getAttribute("data-media") || s
                    ] || s),
                  n && (!s || ((e.matchMedia && matchMedia(s)) || {}).matches))
                ) {
                  !(a = parseFloat(t.getAttribute("data-aspectratio"))) &&
                    n.match(o) &&
                    (a =
                      "w" == RegExp.$2
                        ? RegExp.$1 / RegExp.$3
                        : RegExp.$3 / RegExp.$1);
                  break;
                }
              return a;
            },
            calculateSize: function (e, t) {
              var i,
                o,
                n,
                s,
                r = this.getFit(e),
                a = r.fit,
                l = r.parent;
              return "width" == a ||
                (("contain" == a || "cover" == a) &&
                  (n = this.getImageRatio(e)))
                ? (l ? (t = l.clientWidth) : (l = e),
                  (s = t),
                  "width" == a
                    ? (s = t)
                    : (o = l.clientHeight) > 40 &&
                      (i = t / o) &&
                      (("cover" == a && n > i) || ("contain" == a && i > n)) &&
                      (s = t * (n / i)),
                  s)
                : t;
            },
          };
        (i.parentFit = a),
          t.addEventListener("lazybeforesizes", function (e) {
            if (!e.defaultPrevented && e.detail.instance == i) {
              var t = e.target;
              e.detail.width = a.calculateSize(t, e.detail.width);
            }
          });
      }
    }),
    (function (e, t) {
      var i = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
      };
      (t = t.bind(null, e, e.document)),
        "object" == typeof module && module.exports
          ? t(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes"))
          : e.lazySizes
            ? i()
            : e.addEventListener("lazyunveilread", i, !0);
    })(window, function (e, t, i) {
      "use strict";
      var o,
        n = (i && i.cfg) || e.lazySizesConfig,
        s = t.createElement("img"),
        r = "sizes" in s && "srcset" in s,
        a = /\s+\d+h/g,
        l = (function () {
          var e = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
            i = Array.prototype.forEach;
          return function (o) {
            var n = t.createElement("img"),
              s = function (t) {
                var i,
                  o,
                  n = t.getAttribute(lazySizesConfig.srcsetAttr);
                n &&
                  ((o = n.match(e)) &&
                    (i = "w" == o[2] ? o[1] / o[3] : o[3] / o[1]) &&
                    t.setAttribute("data-aspectratio", i),
                  t.setAttribute(lazySizesConfig.srcsetAttr, n.replace(a, "")));
              },
              r = function (e) {
                var t = e.target.parentNode;
                t &&
                  "PICTURE" == t.nodeName &&
                  i.call(t.getElementsByTagName("source"), s),
                  s(e.target);
              },
              l = function () {
                n.currentSrc && t.removeEventListener("lazybeforeunveil", r);
              };
            o[1] &&
              (t.addEventListener("lazybeforeunveil", r),
              (n.onload = l),
              (n.onerror = l),
              (n.srcset = "data:,a 1w 1h"),
              n.complete && l());
          };
        })();
      if (
        (n || ((n = {}), (e.lazySizesConfig = n)),
        n.supportsType ||
          (n.supportsType = function (e) {
            return !e;
          }),
        !e.picturefill && !n.pf)
      ) {
        if (e.HTMLPictureElement && r)
          return (
            t.msElementsFromPoint &&
              l(navigator.userAgent.match(/Edge\/(\d+)/)),
            void (n.pf = function () {})
          );
        (n.pf = function (t) {
          var i, n;
          if (!e.picturefill)
            for (i = 0, n = t.elements.length; n > i; i++) o(t.elements[i]);
        }),
          (o = (function () {
            var s = function (e, t) {
                return e.w - t.w;
              },
              l = /^\s*\d+\.*\d*px\s*$/,
              d = (function () {
                var e,
                  t = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
                  i = /\s/,
                  o = function (t, i, o, n) {
                    e.push({ c: i, u: o, w: 1 * n });
                  };
                return function (n) {
                  return (
                    (e = []),
                    (n = n.trim()).replace(a, "").replace(t, o),
                    e.length ||
                      !n ||
                      i.test(n) ||
                      e.push({ c: n, u: n, w: 99 }),
                    e
                  );
                };
              })(),
              c = function () {
                var e, i, n;
                c.init ||
                  ((c.init = !0),
                  addEventListener(
                    "resize",
                    ((i = t.getElementsByClassName("lazymatchmedia")),
                    (n = function () {
                      var e, t;
                      for (e = 0, t = i.length; t > e; e++) o(i[e]);
                    }),
                    function () {
                      clearTimeout(e), (e = setTimeout(n, 66));
                    }),
                  ));
              },
              u = function (t, o) {
                var s,
                  r = t.getAttribute("srcset") || t.getAttribute(n.srcsetAttr);
                !r &&
                  o &&
                  (r = t._lazypolyfill
                    ? t._lazypolyfill._set
                    : t.getAttribute(n.srcAttr) || t.getAttribute("src")),
                  (t._lazypolyfill && t._lazypolyfill._set == r) ||
                    ((s = d(r || "")),
                    o &&
                      t.parentNode &&
                      ((s.isPicture =
                        "PICTURE" == t.parentNode.nodeName.toUpperCase()),
                      s.isPicture &&
                        e.matchMedia &&
                        (i.aC(t, "lazymatchmedia"), c())),
                    (s._set = r),
                    Object.defineProperty(t, "_lazypolyfill", {
                      value: s,
                      writable: !0,
                    }));
              },
              p = function (t) {
                var o = e.devicePixelRatio || 1,
                  n = i.getX && i.getX(t);
                return Math.min(n || o, 2.5, o);
              },
              h = function (t) {
                return e.matchMedia
                  ? (h = function (e) {
                      return !e || (matchMedia(e) || {}).matches;
                    })(t)
                  : !t;
              },
              f = function (e) {
                var t, o, r, a, d, c, f;
                if ((u((a = e), !0), (d = a._lazypolyfill).isPicture))
                  for (
                    o = 0,
                      r = (t = e.parentNode.getElementsByTagName("source"))
                        .length;
                    r > o;
                    o++
                  )
                    if (
                      n.supportsType(t[o].getAttribute("type"), e) &&
                      h(t[o].getAttribute("media"))
                    ) {
                      (a = t[o]), u(a), (d = a._lazypolyfill);
                      break;
                    }
                return (
                  d.length > 1
                    ? ((f = a.getAttribute("sizes") || ""),
                      (f =
                        (l.test(f) && parseInt(f, 10)) ||
                        i.gW(e, e.parentNode)),
                      (d.d = p(e)),
                      !d.src || !d.w || d.w < f
                        ? ((d.w = f),
                          (c = (function (e) {
                            for (
                              var t, i, o = e.length, n = e[o - 1], s = 0;
                              o > s;
                              s++
                            )
                              if ((((n = e[s]).d = n.w / e.w), n.d >= e.d)) {
                                !n.cached &&
                                  (t = e[s - 1]) &&
                                  t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
                                  ((i = Math.pow(t.d - 0.6, 1.6)),
                                  t.cached && (t.d += 0.15 * i),
                                  t.d + (n.d - e.d) * i > e.d && (n = t));
                                break;
                              }
                            return n;
                          })(d.sort(s))),
                          (d.src = c))
                        : (c = d.src))
                    : (c = d[0]),
                  c
                );
              },
              g = function (e) {
                if (
                  !r ||
                  !e.parentNode ||
                  "PICTURE" == e.parentNode.nodeName.toUpperCase()
                ) {
                  var t = f(e);
                  t &&
                    t.u &&
                    e._lazypolyfill.cur != t.u &&
                    ((e._lazypolyfill.cur = t.u),
                    (t.cached = !0),
                    e.setAttribute(n.srcAttr, t.u),
                    e.setAttribute("src", t.u));
                }
              };
            return (g.parse = d), g;
          })()),
          n.loadedClass &&
            n.loadingClass &&
            (function () {
              var e = [];
              [
                'img[sizes$="px"][srcset].',
                "picture > img:not([srcset]).",
              ].forEach(function (t) {
                e.push(t + n.loadedClass), e.push(t + n.loadingClass);
              }),
                n.pf({ elements: t.querySelectorAll(e.join(", ")) });
            })();
      }
    }),
    (function (e, t) {
      var i = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
      };
      (t = t.bind(null, e, e.document)),
        "object" == typeof module && module.exports
          ? t(require("lazysizes"))
          : e.lazySizes
            ? i()
            : e.addEventListener("lazyunveilread", i, !0);
    })(window, function (e, t, i) {
      "use strict";
      if (e.addEventListener) {
        var o = /\s+/g,
          n = /\s*\|\s+|\s+\|\s*/g,
          s = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
          r = /\(|\)|'/,
          a = { contain: 1, cover: 1 },
          l = function (e, i, r) {
            var a = t.createElement("picture"),
              l = i.getAttribute(lazySizesConfig.sizesAttr),
              d = i.getAttribute("data-ratio"),
              c = i.getAttribute("data-optimumx");
            i._lazybgset &&
              i._lazybgset.parentNode == i &&
              i.removeChild(i._lazybgset),
              Object.defineProperty(r, "_lazybgset", {
                value: i,
                writable: !0,
              }),
              Object.defineProperty(i, "_lazybgset", {
                value: a,
                writable: !0,
              }),
              (e = e.replace(o, " ").split(n)),
              (a.style.display = "none"),
              (r.className = lazySizesConfig.lazyClass),
              1 != e.length || l || (l = "auto"),
              e.forEach(function (e) {
                var i = t.createElement("source");
                l && "auto" != l && i.setAttribute("sizes", l),
                  e.match(s) &&
                    (i.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1),
                    RegExp.$2 &&
                      i.setAttribute(
                        "media",
                        lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2,
                      )),
                  a.appendChild(i);
              }),
              l &&
                (r.setAttribute(lazySizesConfig.sizesAttr, l),
                i.removeAttribute(lazySizesConfig.sizesAttr),
                i.removeAttribute("sizes")),
              c && r.setAttribute("data-optimumx", c),
              d && r.setAttribute("data-ratio", d),
              a.appendChild(r),
              i.appendChild(a);
          },
          d = function (e) {
            if (e.target._lazybgset) {
              var t = e.target,
                o = t._lazybgset,
                n = t.currentSrc || t.src;
              n &&
                (o.style.backgroundImage =
                  "url(" + (r.test(n) ? JSON.stringify(n) : n) + ")"),
                t._lazybgsetLoading &&
                  (i.fire(o, "_lazyloaded", {}, !1, !0),
                  delete t._lazybgsetLoading);
            }
          };
        addEventListener("lazybeforeunveil", function (e) {
          var o, n, s;
          !e.defaultPrevented &&
            (o = e.target.getAttribute("data-bgset")) &&
            ((s = e.target),
            ((n = t.createElement("img")).alt = ""),
            (n._lazybgsetLoading = !0),
            (e.detail.firesLoad = !0),
            l(o, s, n),
            setTimeout(function () {
              i.loader.unveil(n),
                i.rAF(function () {
                  i.fire(n, "_lazyloaded", {}, !0, !0),
                    n.complete && d({ target: n });
                });
            }));
        }),
          t.addEventListener("load", d, !0),
          e.addEventListener(
            "lazybeforesizes",
            function (e) {
              if (
                e.detail.instance == i &&
                e.target._lazybgset &&
                e.detail.dataAttr
              ) {
                var t = (function (e) {
                  var t;
                  return (
                    (t = (
                      getComputedStyle(e) || {
                        getPropertyValue: function () {},
                      }
                    ).getPropertyValue("background-size")),
                    !a[t] &&
                      a[e.style.backgroundSize] &&
                      (t = e.style.backgroundSize),
                    t
                  );
                })(e.target._lazybgset);
                a[t] &&
                  ((e.target._lazysizesParentFit = t),
                  i.rAF(function () {
                    e.target.setAttribute("data-parent-fit", t),
                      e.target._lazysizesParentFit &&
                        delete e.target._lazysizesParentFit;
                  }));
              }
            },
            !0,
          ),
          t.documentElement.addEventListener("lazybeforesizes", function (e) {
            !e.defaultPrevented &&
              e.target._lazybgset &&
              e.detail.instance == i &&
              (e.detail.width = (function (e) {
                var t = i.gW(e, e.parentNode);
                return (
                  (!e._lazysizesWidth || t > e._lazysizesWidth) &&
                    (e._lazysizesWidth = t),
                  e._lazysizesWidth
                );
              })(e.target._lazybgset));
          });
      }
    }),
    document.addEventListener("lazyloaded", function (e) {
      e.target.parentElement.className =
        e.target.parentElement.className.replace("lazyload--placeholder", "");
    }),
    function () {
      function e() {}
      function t(e, t) {
        for (var i = e.length; i--; ) if (e[i].listener === t) return i;
        return -1;
      }
      function i(e) {
        return function () {
          return this[e].apply(this, arguments);
        };
      }
      var o = e.prototype,
        n = this,
        s = n.EventEmitter;
      (o.getListeners = function (e) {
        var t,
          i,
          o = this._getEvents();
        if ("object" == typeof e)
          for (i in ((t = {}), o))
            o.hasOwnProperty(i) && e.test(i) && (t[i] = o[i]);
        else t = o[e] || (o[e] = []);
        return t;
      }),
        (o.flattenListeners = function (e) {
          var t,
            i = [];
          for (t = 0; e.length > t; t += 1) i.push(e[t].listener);
          return i;
        }),
        (o.getListenersAsObject = function (e) {
          var t,
            i = this.getListeners(e);
          return i instanceof Array && ((t = {})[e] = i), t || i;
        }),
        (o.addListener = function (e, i) {
          var o,
            n = this.getListenersAsObject(e),
            s = "object" == typeof i;
          for (o in n)
            n.hasOwnProperty(o) &&
              -1 === t(n[o], i) &&
              n[o].push(s ? i : { listener: i, once: !1 });
          return this;
        }),
        (o.on = i("addListener")),
        (o.addOnceListener = function (e, t) {
          return this.addListener(e, { listener: t, once: !0 });
        }),
        (o.once = i("addOnceListener")),
        (o.defineEvent = function (e) {
          return this.getListeners(e), this;
        }),
        (o.defineEvents = function (e) {
          for (var t = 0; e.length > t; t += 1) this.defineEvent(e[t]);
          return this;
        }),
        (o.removeListener = function (e, i) {
          var o,
            n,
            s = this.getListenersAsObject(e);
          for (n in s)
            s.hasOwnProperty(n) && -1 !== (o = t(s[n], i)) && s[n].splice(o, 1);
          return this;
        }),
        (o.off = i("removeListener")),
        (o.addListeners = function (e, t) {
          return this.manipulateListeners(!1, e, t);
        }),
        (o.removeListeners = function (e, t) {
          return this.manipulateListeners(!0, e, t);
        }),
        (o.manipulateListeners = function (e, t, i) {
          var o,
            n,
            s = e ? this.removeListener : this.addListener,
            r = e ? this.removeListeners : this.addListeners;
          if ("object" != typeof t || t instanceof RegExp)
            for (o = i.length; o--; ) s.call(this, t, i[o]);
          else
            for (o in t)
              t.hasOwnProperty(o) &&
                (n = t[o]) &&
                ("function" == typeof n
                  ? s.call(this, o, n)
                  : r.call(this, o, n));
          return this;
        }),
        (o.removeEvent = function (e) {
          var t,
            i = typeof e,
            o = this._getEvents();
          if ("string" === i) delete o[e];
          else if ("object" === i)
            for (t in o) o.hasOwnProperty(t) && e.test(t) && delete o[t];
          else delete this._events;
          return this;
        }),
        (o.removeAllListeners = i("removeEvent")),
        (o.emitEvent = function (e, t) {
          var i,
            o,
            n,
            s = this.getListenersAsObject(e);
          for (n in s)
            if (s.hasOwnProperty(n))
              for (o = s[n].length; o--; )
                !0 === (i = s[n][o]).once && this.removeListener(e, i.listener),
                  i.listener.apply(this, t || []) ===
                    this._getOnceReturnValue() &&
                    this.removeListener(e, i.listener);
          return this;
        }),
        (o.trigger = i("emitEvent")),
        (o.emit = function (e) {
          var t = Array.prototype.slice.call(arguments, 1);
          return this.emitEvent(e, t);
        }),
        (o.setOnceReturnValue = function (e) {
          return (this._onceReturnValue = e), this;
        }),
        (o._getOnceReturnValue = function () {
          return (
            !this.hasOwnProperty("_onceReturnValue") || this._onceReturnValue
          );
        }),
        (o._getEvents = function () {
          return this._events || (this._events = {});
        }),
        (e.noConflict = function () {
          return (n.EventEmitter = s), e;
        }),
        "object" == typeof module && module.exports
          ? (module.exports = e)
          : (this.EventEmitter = e);
    }.call(this),
    (function (e) {
      function t(t) {
        var i = e.event;
        return (i.target = i.target || i.srcElement || t), i;
      }
      var i = document.documentElement,
        o = function () {};
      i.addEventListener
        ? (o = function (e, t, i) {
            e.addEventListener(t, i, !1);
          })
        : i.attachEvent &&
          (o = function (e, i, o) {
            (e[i + o] = o.handleEvent
              ? function () {
                  var i = t(e);
                  o.handleEvent.call(o, i);
                }
              : function () {
                  var i = t(e);
                  o.call(e, i);
                }),
              e.attachEvent("on" + i, e[i + o]);
          });
      var n = function () {};
      i.removeEventListener
        ? (n = function (e, t, i) {
            e.removeEventListener(t, i, !1);
          })
        : i.detachEvent &&
          (n = function (e, t, i) {
            e.detachEvent("on" + t, e[t + i]);
            try {
              delete e[t + i];
            } catch (o) {
              e[t + i] = void 0;
            }
          });
      var s = { bind: o, unbind: n };
      e.eventie = s;
    })(this),
    (o = window),
    (n = function (e, t, i) {
      function o(e, t) {
        for (var i in t) e[i] = t[i];
        return e;
      }
      function n(e) {
        var t = [];
        if (
          (function (e) {
            return "[object Array]" === u.call(e);
          })(e)
        )
          t = e;
        else if ("number" == typeof e.length)
          for (var i = 0, o = e.length; o > i; i++) t.push(e[i]);
        else t.push(e);
        return t;
      }
      function s(e, t, i) {
        if (!(this instanceof s)) return new s(e, t);
        "string" == typeof e && (e = document.querySelectorAll(e)),
          (this.elements = n(e)),
          (this.options = o({}, this.options)),
          "function" == typeof t ? (i = t) : o(this.options, t),
          i && this.on("always", i),
          this.getImages(),
          l && (this.jqDeferred = new l.Deferred());
        var r = this;
        setTimeout(function () {
          r.check();
        });
      }
      function r(e) {
        this.img = e;
      }
      function a(e) {
        (this.src = e), (p[e] = this);
      }
      var l = e.jQuery,
        d = e.console,
        c = void 0 !== d,
        u = Object.prototype.toString;
      (s.prototype = new t()),
        (s.prototype.options = {}),
        (s.prototype.getImages = function () {
          this.images = [];
          for (var e = 0, t = this.elements.length; t > e; e++) {
            var i = this.elements[e];
            "IMG" === i.nodeName && this.addImage(i);
            var o = i.nodeType;
            if (o && (1 === o || 9 === o || 11 === o))
              for (
                var n = i.querySelectorAll("img"), s = 0, r = n.length;
                r > s;
                s++
              ) {
                var a = n[s];
                this.addImage(a);
              }
          }
        }),
        (s.prototype.addImage = function (e) {
          var t = new r(e);
          this.images.push(t);
        }),
        (s.prototype.check = function () {
          function e(e, n) {
            return (
              t.options.debug && c && d.log("confirm", e, n),
              t.progress(e),
              ++i === o && t.complete(),
              !0
            );
          }
          var t = this,
            i = 0,
            o = this.images.length;
          if (((this.hasAnyBroken = !1), o))
            for (var n = 0; o > n; n++) {
              var s = this.images[n];
              s.on("confirm", e), s.check();
            }
          else this.complete();
        }),
        (s.prototype.progress = function (e) {
          this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded;
          var t = this;
          setTimeout(function () {
            t.emit("progress", t, e),
              t.jqDeferred && t.jqDeferred.notify && t.jqDeferred.notify(t, e);
          });
        }),
        (s.prototype.complete = function () {
          var e = this.hasAnyBroken ? "fail" : "done";
          this.isComplete = !0;
          var t = this;
          setTimeout(function () {
            if ((t.emit(e, t), t.emit("always", t), t.jqDeferred)) {
              var i = t.hasAnyBroken ? "reject" : "resolve";
              t.jqDeferred[i](t);
            }
          });
        }),
        l &&
          (l.fn.imagesLoaded = function (e, t) {
            return new s(this, e, t).jqDeferred.promise(l(this));
          }),
        (r.prototype = new t()),
        (r.prototype.check = function () {
          var e = p[this.img.src] || new a(this.img.src);
          if (e.isConfirmed) this.confirm(e.isLoaded, "cached was confirmed");
          else if (this.img.complete && void 0 !== this.img.naturalWidth)
            this.confirm(0 !== this.img.naturalWidth, "naturalWidth");
          else {
            var t = this;
            e.on("confirm", function (e, i) {
              return t.confirm(e.isLoaded, i), !0;
            }),
              e.check();
          }
        }),
        (r.prototype.confirm = function (e, t) {
          (this.isLoaded = e), this.emit("confirm", this, t);
        });
      var p = {};
      return (
        (a.prototype = new t()),
        (a.prototype.check = function () {
          if (!this.isChecked) {
            var e = new Image();
            i.bind(e, "load", this),
              i.bind(e, "error", this),
              (e.src = this.src),
              (this.isChecked = !0);
          }
        }),
        (a.prototype.handleEvent = function (e) {
          var t = "on" + e.type;
          this[t] && this[t](e);
        }),
        (a.prototype.onload = function (e) {
          this.confirm(!0, "onload"), this.unbindProxyEvents(e);
        }),
        (a.prototype.onerror = function (e) {
          this.confirm(!1, "onerror"), this.unbindProxyEvents(e);
        }),
        (a.prototype.confirm = function (e, t) {
          (this.isConfirmed = !0),
            (this.isLoaded = e),
            this.emit("confirm", this, t);
        }),
        (a.prototype.unbindProxyEvents = function (e) {
          i.unbind(e.target, "load", this), i.unbind(e.target, "error", this);
        }),
        s
      );
    }),
    "object" == typeof exports
      ? (module.exports = n(
          o,
          require("wolfy87-eventemitter"),
          require("eventie"),
        ))
      : (o.imagesLoaded = n(o, o.EventEmitter, o.eventie)),
    (function (e) {
      "use strict";
      "undefined" != typeof exports
        ? (module.exports = e(require("jquery")))
        : e(jQuery);
    })(function (e) {
      "use strict";
      var t = window.Slick || {};
      ((t = (function () {
        var t = 0;
        return function (i, o) {
          var n,
            s = this;
          (s.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: e(i),
            appendDots: e(i),
            arrows: !0,
            asNavFor: null,
            prevArrow:
              '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
            nextArrow:
              '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function (e, t) {
              return (
                '<button type="button" data-role="none" role="button" aria-required="false" tabindex="0">' +
                (t + 1) +
                "</button>"
              );
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: 0.35,
            fade: !1,
            focusOnSelect: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !1,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3,
          }),
            (s.initials = {
              animating: !1,
              dragging: !1,
              autoPlayTimer: null,
              currentDirection: 0,
              currentLeft: null,
              currentSlide: 0,
              direction: 1,
              $dots: null,
              listWidth: null,
              listHeight: null,
              loadIndex: 0,
              $nextArrow: null,
              $prevArrow: null,
              slideCount: null,
              slideWidth: null,
              $slideTrack: null,
              $slides: null,
              sliding: !1,
              slideOffset: 0,
              swipeLeft: null,
              $list: null,
              touchObject: {},
              transformsEnabled: !1,
              unslicked: !1,
            }),
            e.extend(s, s.initials),
            (s.activeBreakpoint = null),
            (s.animType = null),
            (s.animProp = null),
            (s.breakpoints = []),
            (s.breakpointSettings = []),
            (s.cssTransitions = !1),
            (s.hidden = "hidden"),
            (s.paused = !1),
            (s.positionProp = null),
            (s.respondTo = null),
            (s.rowCount = 1),
            (s.shouldClick = !0),
            (s.$slider = e(i)),
            (s.$slidesCache = null),
            (s.transformType = null),
            (s.transitionType = null),
            (s.visibilityChange = "visibilitychange"),
            (s.windowWidth = 0),
            (s.windowTimer = null),
            (n = e(i).data("slick") || {}),
            (s.options = e.extend({}, s.defaults, n, o)),
            (s.currentSlide = s.options.initialSlide),
            (s.originalSettings = s.options),
            void 0 !== document.mozHidden
              ? ((s.hidden = "mozHidden"),
                (s.visibilityChange = "mozvisibilitychange"))
              : void 0 !== document.webkitHidden &&
                ((s.hidden = "webkitHidden"),
                (s.visibilityChange = "webkitvisibilitychange")),
            (s.autoPlay = e.proxy(s.autoPlay, s)),
            (s.autoPlayClear = e.proxy(s.autoPlayClear, s)),
            (s.changeSlide = e.proxy(s.changeSlide, s)),
            (s.clickHandler = e.proxy(s.clickHandler, s)),
            (s.selectHandler = e.proxy(s.selectHandler, s)),
            (s.setPosition = e.proxy(s.setPosition, s)),
            (s.swipeHandler = e.proxy(s.swipeHandler, s)),
            (s.dragHandler = e.proxy(s.dragHandler, s)),
            (s.keyHandler = e.proxy(s.keyHandler, s)),
            (s.autoPlayIterator = e.proxy(s.autoPlayIterator, s)),
            (s.instanceUid = t++),
            (s.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
            s.registerBreakpoints(),
            s.init(!0),
            s.checkResponsive(!0);
        };
      })()).prototype.addSlide = t.prototype.slickAdd =
        function (t, i, o) {
          var n = this;
          if ("boolean" == typeof i) (o = i), (i = null);
          else if (0 > i || i >= n.slideCount) return !1;
          n.unload(),
            "number" == typeof i
              ? 0 === i && 0 === n.$slides.length
                ? e(t).appendTo(n.$slideTrack)
                : o
                  ? e(t).insertBefore(n.$slides.eq(i))
                  : e(t).insertAfter(n.$slides.eq(i))
              : !0 === o
                ? e(t).prependTo(n.$slideTrack)
                : e(t).appendTo(n.$slideTrack),
            (n.$slides = n.$slideTrack.children(this.options.slide)),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.append(n.$slides),
            n.$slides.each(function (t, i) {
              e(i).attr("data-slick-index", t);
            }),
            (n.$slidesCache = n.$slides),
            n.reinit();
        }),
        (t.prototype.animateHeight = function () {
          var e = this;
          if (
            1 === e.options.slidesToShow &&
            !0 === e.options.adaptiveHeight &&
            !1 === e.options.vertical
          ) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.animate({ height: t }, e.options.speed);
          }
        }),
        (t.prototype.animateSlide = function (t, i) {
          var o = {},
            n = this;
          n.animateHeight(),
            !0 === n.options.rtl && !1 === n.options.vertical && (t = -t),
            !1 === n.transformsEnabled
              ? !1 === n.options.vertical
                ? n.$slideTrack.animate(
                    { left: t },
                    n.options.speed,
                    n.options.easing,
                    i,
                  )
                : n.$slideTrack.animate(
                    { top: t },
                    n.options.speed,
                    n.options.easing,
                    i,
                  )
              : !1 === n.cssTransitions
                ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
                  e({ animStart: n.currentLeft }).animate(
                    { animStart: t },
                    {
                      duration: n.options.speed,
                      easing: n.options.easing,
                      step: function (e) {
                        (e = Math.ceil(e)),
                          !1 === n.options.vertical
                            ? ((o[n.animType] = "translate(" + e + "px, 0px)"),
                              n.$slideTrack.css(o))
                            : ((o[n.animType] = "translate(0px," + e + "px)"),
                              n.$slideTrack.css(o));
                      },
                      complete: function () {
                        i && i.call();
                      },
                    },
                  ))
                : (n.applyTransition(),
                  (t = Math.ceil(t)),
                  !1 === n.options.vertical
                    ? (o[n.animType] = "translate3d(" + t + "px, 0px, 0px)")
                    : (o[n.animType] = "translate3d(0px," + t + "px, 0px)"),
                  n.$slideTrack.css(o),
                  i &&
                    setTimeout(function () {
                      n.disableTransition(), i.call();
                    }, n.options.speed));
        }),
        (t.prototype.asNavFor = function (t) {
          var i = this.options.asNavFor;
          i && null !== i && (i = e(i).not(this.$slider)),
            null !== i &&
              "object" == typeof i &&
              i.each(function () {
                var i = e(this).slick("getSlick");
                i.unslicked || i.slideHandler(t, !0);
              });
        }),
        (t.prototype.applyTransition = function (e) {
          var t = this,
            i = {};
          !1 === t.options.fade
            ? (i[t.transitionType] =
                t.transformType +
                " " +
                t.options.speed +
                "ms " +
                t.options.cssEase)
            : (i[t.transitionType] =
                "opacity " + t.options.speed + "ms " + t.options.cssEase),
            !1 === t.options.fade
              ? t.$slideTrack.css(i)
              : t.$slides.eq(e).css(i);
        }),
        (t.prototype.autoPlay = function () {
          var e = this;
          e.autoPlayTimer && clearInterval(e.autoPlayTimer),
            e.slideCount > e.options.slidesToShow &&
              !0 !== e.paused &&
              (e.autoPlayTimer = setInterval(
                e.autoPlayIterator,
                e.options.autoplaySpeed,
              ));
        }),
        (t.prototype.autoPlayClear = function () {
          this.autoPlayTimer && clearInterval(this.autoPlayTimer);
        }),
        (t.prototype.autoPlayIterator = function () {
          var e = this;
          !1 === e.options.infinite
            ? 1 === e.direction
              ? (e.currentSlide + 1 === e.slideCount - 1 && (e.direction = 0),
                e.slideHandler(e.currentSlide + e.options.slidesToScroll))
              : (e.currentSlide - 1 == 0 && (e.direction = 1),
                e.slideHandler(e.currentSlide - e.options.slidesToScroll))
            : e.slideHandler(e.currentSlide + e.options.slidesToScroll);
        }),
        (t.prototype.buildArrows = function () {
          var t = this;
          !0 === t.options.arrows &&
            ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
            (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
            t.slideCount > t.options.slidesToShow
              ? (t.$prevArrow
                  .removeClass("slick-hidden")
                  .removeAttr("aria-hidden tabindex"),
                t.$nextArrow
                  .removeClass("slick-hidden")
                  .removeAttr("aria-hidden tabindex"),
                t.htmlExpr.test(t.options.prevArrow) &&
                  t.$prevArrow.prependTo(t.options.appendArrows),
                t.htmlExpr.test(t.options.nextArrow) &&
                  t.$nextArrow.appendTo(t.options.appendArrows),
                !0 !== t.options.infinite &&
                  t.$prevArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"))
              : t.$prevArrow
                  .add(t.$nextArrow)
                  .addClass("slick-hidden")
                  .attr({ "aria-disabled": "true", tabindex: "-1" }));
        }),
        (t.prototype.buildDots = function () {
          var t,
            i,
            o = this;
          if (!0 === o.options.dots && o.slideCount > o.options.slidesToShow) {
            for (
              i = '<ul class="' + o.options.dotsClass + '">', t = 0;
              t <= o.getDotCount();
              t += 1
            )
              i += "<li>" + o.options.customPaging.call(this, o, t) + "</li>";
            (i += "</ul>"),
              (o.$dots = e(i).appendTo(o.options.appendDots)),
              o.$dots
                .find("li")
                .first()
                .addClass("slick-active")
                .attr("aria-hidden", "false");
          }
        }),
        (t.prototype.buildOut = function () {
          var t = this;
          (t.$slides = t.$slider
            .children(t.options.slide + ":not(.slick-cloned)")
            .addClass("slick-slide")),
            (t.slideCount = t.$slides.length),
            t.$slides.each(function (t, i) {
              e(i)
                .attr("data-slick-index", t)
                .data("originalStyling", e(i).attr("style") || "");
            }),
            t.$slider.addClass("slick-slider"),
            (t.$slideTrack =
              0 === t.slideCount
                ? e('<div class="slick-track"/>').appendTo(t.$slider)
                : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
            (t.$list = t.$slideTrack
              .wrap('<div aria-live="polite" class="slick-list"/>')
              .parent()),
            t.$slideTrack.css("opacity", 0),
            (!0 === t.options.centerMode || !0 === t.options.swipeToSlide) &&
              (t.options.slidesToScroll = 1),
            e("img[data-lazy]", t.$slider)
              .not("[src]")
              .addClass("slick-loading"),
            t.setupInfinite(),
            t.buildArrows(),
            t.buildDots(),
            t.updateDots(),
            t.setSlideClasses(
              "number" == typeof t.currentSlide ? t.currentSlide : 0,
            ),
            !0 === t.options.draggable && t.$list.addClass("draggable");
        }),
        (t.prototype.buildRows = function () {
          var e,
            t,
            i,
            o,
            n,
            s,
            r,
            a = this;
          if (
            ((o = document.createDocumentFragment()),
            (s = a.$slider.children()),
            a.options.rows > 1)
          ) {
            for (
              r = a.options.slidesPerRow * a.options.rows,
                n = Math.ceil(s.length / r),
                e = 0;
              n > e;
              e++
            ) {
              var l = document.createElement("div");
              for (t = 0; t < a.options.rows; t++) {
                var d = document.createElement("div");
                for (i = 0; i < a.options.slidesPerRow; i++) {
                  var c = e * r + (t * a.options.slidesPerRow + i);
                  s.get(c) && d.appendChild(s.get(c));
                }
                l.appendChild(d);
              }
              o.appendChild(l);
            }
            a.$slider.html(o),
              a.$slider
                .children()
                .children()
                .children()
                .css({
                  width: 100 / a.options.slidesPerRow + "%",
                  display: "inline-block",
                });
          }
        }),
        (t.prototype.checkResponsive = function (t, i) {
          var o,
            n,
            s,
            r = this,
            a = !1,
            l = r.$slider.width(),
            d = window.innerWidth || e(window).width();
          if (
            ("window" === r.respondTo
              ? (s = d)
              : "slider" === r.respondTo
                ? (s = l)
                : "min" === r.respondTo && (s = Math.min(d, l)),
            r.options.responsive &&
              r.options.responsive.length &&
              null !== r.options.responsive)
          ) {
            for (o in ((n = null), r.breakpoints))
              r.breakpoints.hasOwnProperty(o) &&
                (!1 === r.originalSettings.mobileFirst
                  ? s < r.breakpoints[o] && (n = r.breakpoints[o])
                  : s > r.breakpoints[o] && (n = r.breakpoints[o]));
            null !== n
              ? null !== r.activeBreakpoint
                ? (n !== r.activeBreakpoint || i) &&
                  ((r.activeBreakpoint = n),
                  "unslick" === r.breakpointSettings[n]
                    ? r.unslick(n)
                    : ((r.options = e.extend(
                        {},
                        r.originalSettings,
                        r.breakpointSettings[n],
                      )),
                      !0 === t && (r.currentSlide = r.options.initialSlide),
                      r.refresh(t)),
                  (a = n))
                : ((r.activeBreakpoint = n),
                  "unslick" === r.breakpointSettings[n]
                    ? r.unslick(n)
                    : ((r.options = e.extend(
                        {},
                        r.originalSettings,
                        r.breakpointSettings[n],
                      )),
                      !0 === t && (r.currentSlide = r.options.initialSlide),
                      r.refresh(t)),
                  (a = n))
              : null !== r.activeBreakpoint &&
                ((r.activeBreakpoint = null),
                (r.options = r.originalSettings),
                !0 === t && (r.currentSlide = r.options.initialSlide),
                r.refresh(t),
                (a = n)),
              t || !1 === a || r.$slider.trigger("breakpoint", [r, a]);
          }
        }),
        (t.prototype.changeSlide = function (t, i) {
          var o,
            n,
            s = this,
            r = e(t.target);
          switch (
            (r.is("a") && t.preventDefault(),
            r.is("li") || (r = r.closest("li")),
            (o =
              s.slideCount % s.options.slidesToScroll != 0
                ? 0
                : (s.slideCount - s.currentSlide) % s.options.slidesToScroll),
            t.data.message)
          ) {
            case "previous":
              (n =
                0 === o
                  ? s.options.slidesToScroll
                  : s.options.slidesToShow - o),
                s.slideCount > s.options.slidesToShow &&
                  s.slideHandler(s.currentSlide - n, !1, i);
              break;
            case "next":
              (n = 0 === o ? s.options.slidesToScroll : o),
                s.slideCount > s.options.slidesToShow &&
                  s.slideHandler(s.currentSlide + n, !1, i);
              break;
            case "index":
              var a =
                0 === t.data.index
                  ? 0
                  : t.data.index || r.index() * s.options.slidesToScroll;
              s.slideHandler(s.checkNavigable(a), !1, i),
                r.children().trigger("focus");
              break;
            default:
              return;
          }
        }),
        (t.prototype.checkNavigable = function (e) {
          var t, i;
          if (((i = 0), e > (t = this.getNavigableIndexes())[t.length - 1]))
            e = t[t.length - 1];
          else
            for (var o in t) {
              if (e < t[o]) {
                e = i;
                break;
              }
              i = t[o];
            }
          return e;
        }),
        (t.prototype.cleanUpEvents = function () {
          var t = this;
          t.options.dots &&
            null !== t.$dots &&
            (e("li", t.$dots).off("click.slick", t.changeSlide),
            !0 === t.options.pauseOnDotsHover &&
              !0 === t.options.autoplay &&
              e("li", t.$dots)
                .off("mouseenter.slick", e.proxy(t.setPaused, t, !0))
                .off("mouseleave.slick", e.proxy(t.setPaused, t, !1))),
            !0 === t.options.arrows &&
              t.slideCount > t.options.slidesToShow &&
              (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide),
              t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide)),
            t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
            t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
            t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
            t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
            t.$list.off("click.slick", t.clickHandler),
            e(document).off(t.visibilityChange, t.visibility),
            t.$list.off("mouseenter.slick", e.proxy(t.setPaused, t, !0)),
            t.$list.off("mouseleave.slick", e.proxy(t.setPaused, t, !1)),
            !0 === t.options.accessibility &&
              t.$list.off("keydown.slick", t.keyHandler),
            !0 === t.options.focusOnSelect &&
              e(t.$slideTrack).children().off("click.slick", t.selectHandler),
            e(window).off(
              "orientationchange.slick.slick-" + t.instanceUid,
              t.orientationChange,
            ),
            e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
            e("[draggable!=true]", t.$slideTrack).off(
              "dragstart",
              t.preventDefault,
            ),
            e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition),
            e(document).off(
              "ready.slick.slick-" + t.instanceUid,
              t.setPosition,
            );
        }),
        (t.prototype.cleanUpRows = function () {
          var e,
            t = this;
          t.options.rows > 1 &&
            ((e = t.$slides.children().children()).removeAttr("style"),
            t.$slider.html(e));
        }),
        (t.prototype.clickHandler = function (e) {
          !1 === this.shouldClick &&
            (e.stopImmediatePropagation(),
            e.stopPropagation(),
            e.preventDefault());
        }),
        (t.prototype.destroy = function (t) {
          var i = this;
          i.autoPlayClear(),
            (i.touchObject = {}),
            i.cleanUpEvents(),
            e(".slick-cloned", i.$slider).detach(),
            i.$dots && i.$dots.remove(),
            i.$prevArrow &&
              i.$prevArrow.length &&
              (i.$prevArrow
                .removeClass("slick-disabled slick-arrow slick-hidden")
                .removeAttr("aria-hidden aria-disabled tabindex")
                .css("display", ""),
              i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()),
            i.$nextArrow &&
              i.$nextArrow.length &&
              (i.$nextArrow
                .removeClass("slick-disabled slick-arrow slick-hidden")
                .removeAttr("aria-hidden aria-disabled tabindex")
                .css("display", ""),
              i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()),
            i.$slides &&
              (i.$slides
                .removeClass(
                  "slick-slide slick-active slick-center slick-visible slick-current",
                )
                .removeAttr("aria-hidden")
                .removeAttr("data-slick-index")
                .each(function () {
                  e(this).attr("style", e(this).data("originalStyling"));
                }),
              i.$slideTrack.children(this.options.slide).detach(),
              i.$slideTrack.detach(),
              i.$list.detach(),
              i.$slider.append(i.$slides)),
            i.cleanUpRows(),
            i.$slider.removeClass("slick-slider"),
            i.$slider.removeClass("slick-initialized"),
            (i.unslicked = !0),
            t || i.$slider.trigger("destroy", [i]);
        }),
        (t.prototype.disableTransition = function (e) {
          var t = this,
            i = {};
          (i[t.transitionType] = ""),
            !1 === t.options.fade
              ? t.$slideTrack.css(i)
              : t.$slides.eq(e).css(i);
        }),
        (t.prototype.fadeSlide = function (e, t) {
          var i = this;
          !1 === i.cssTransitions
            ? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }),
              i.$slides
                .eq(e)
                .animate({ opacity: 1 }, i.options.speed, i.options.easing, t))
            : (i.applyTransition(e),
              i.$slides.eq(e).css({ opacity: 1, zIndex: i.options.zIndex }),
              t &&
                setTimeout(function () {
                  i.disableTransition(e), t.call();
                }, i.options.speed));
        }),
        (t.prototype.fadeSlideOut = function (e) {
          var t = this;
          !1 === t.cssTransitions
            ? t.$slides
                .eq(e)
                .animate(
                  { opacity: 0, zIndex: t.options.zIndex - 2 },
                  t.options.speed,
                  t.options.easing,
                )
            : (t.applyTransition(e),
              t.$slides
                .eq(e)
                .css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
        }),
        (t.prototype.filterSlides = t.prototype.slickFilter =
          function (e) {
            var t = this;
            null !== e &&
              ((t.$slidesCache = t.$slides),
              t.unload(),
              t.$slideTrack.children(this.options.slide).detach(),
              t.$slidesCache.filter(e).appendTo(t.$slideTrack),
              t.reinit());
          }),
        (t.prototype.getCurrent = t.prototype.slickCurrentSlide =
          function () {
            return this.currentSlide;
          }),
        (t.prototype.getDotCount = function () {
          var e = this,
            t = 0,
            i = 0,
            o = 0;
          if (!0 === e.options.infinite)
            for (; t < e.slideCount; )
              ++o,
                (t = i + e.options.slidesToScroll),
                (i +=
                  e.options.slidesToScroll <= e.options.slidesToShow
                    ? e.options.slidesToScroll
                    : e.options.slidesToShow);
          else if (!0 === e.options.centerMode) o = e.slideCount;
          else
            for (; t < e.slideCount; )
              ++o,
                (t = i + e.options.slidesToScroll),
                (i +=
                  e.options.slidesToScroll <= e.options.slidesToShow
                    ? e.options.slidesToScroll
                    : e.options.slidesToShow);
          return o - 1;
        }),
        (t.prototype.getLeft = function (e) {
          var t,
            i,
            o,
            n = this,
            s = 0;
          return (
            (n.slideOffset = 0),
            (i = n.$slides.first().outerHeight(!0)),
            !0 === n.options.infinite
              ? (n.slideCount > n.options.slidesToShow &&
                  ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
                  (s = i * n.options.slidesToShow * -1)),
                n.slideCount % n.options.slidesToScroll != 0 &&
                  e + n.options.slidesToScroll > n.slideCount &&
                  n.slideCount > n.options.slidesToShow &&
                  (e > n.slideCount
                    ? ((n.slideOffset =
                        (n.options.slidesToShow - (e - n.slideCount)) *
                        n.slideWidth *
                        -1),
                      (s =
                        (n.options.slidesToShow - (e - n.slideCount)) * i * -1))
                    : ((n.slideOffset =
                        (n.slideCount % n.options.slidesToScroll) *
                        n.slideWidth *
                        -1),
                      (s =
                        (n.slideCount % n.options.slidesToScroll) * i * -1))))
              : e + n.options.slidesToShow > n.slideCount &&
                ((n.slideOffset =
                  (e + n.options.slidesToShow - n.slideCount) * n.slideWidth),
                (s = (e + n.options.slidesToShow - n.slideCount) * i)),
            n.slideCount <= n.options.slidesToShow &&
              ((n.slideOffset = 0), (s = 0)),
            !0 === n.options.centerMode && !0 === n.options.infinite
              ? (n.slideOffset +=
                  n.slideWidth * Math.floor(n.options.slidesToShow / 2) -
                  n.slideWidth)
              : !0 === n.options.centerMode &&
                ((n.slideOffset = 0),
                (n.slideOffset +=
                  n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
            (t =
              !1 === n.options.vertical
                ? e * n.slideWidth * -1 + n.slideOffset
                : e * i * -1 + s),
            !0 === n.options.variableWidth &&
              ((o =
                n.slideCount <= n.options.slidesToShow ||
                !1 === n.options.infinite
                  ? n.$slideTrack.children(".slick-slide").eq(e)
                  : n.$slideTrack
                      .children(".slick-slide")
                      .eq(e + n.options.slidesToShow)),
              (t =
                !0 === n.options.rtl
                  ? o[0]
                    ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                    : 0
                  : o[0]
                    ? -1 * o[0].offsetLeft
                    : 0),
              !0 === n.options.centerMode &&
                ((o =
                  n.slideCount <= n.options.slidesToShow ||
                  !1 === n.options.infinite
                    ? n.$slideTrack.children(".slick-slide").eq(e)
                    : n.$slideTrack
                        .children(".slick-slide")
                        .eq(e + n.options.slidesToShow + 1)),
                (t =
                  !0 === n.options.rtl
                    ? o[0]
                      ? -1 *
                        (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                      : 0
                    : o[0]
                      ? -1 * o[0].offsetLeft
                      : 0),
                (t += (n.$list.width() - o.outerWidth()) / 2))),
            t
          );
        }),
        (t.prototype.getOption = t.prototype.slickGetOption =
          function (e) {
            return this.options[e];
          }),
        (t.prototype.getNavigableIndexes = function () {
          var e,
            t = this,
            i = 0,
            o = 0,
            n = [];
          for (
            !1 === t.options.infinite
              ? (e = t.slideCount)
              : ((i = -1 * t.options.slidesToScroll),
                (o = -1 * t.options.slidesToScroll),
                (e = 2 * t.slideCount));
            e > i;

          )
            n.push(i),
              (i = o + t.options.slidesToScroll),
              (o +=
                t.options.slidesToScroll <= t.options.slidesToShow
                  ? t.options.slidesToScroll
                  : t.options.slidesToShow);
          return n;
        }),
        (t.prototype.getSlick = function () {
          return this;
        }),
        (t.prototype.getSlideCount = function () {
          var t,
            i,
            o = this;
          return (
            (i =
              !0 === o.options.centerMode
                ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
                : 0),
            !0 === o.options.swipeToSlide
              ? (o.$slideTrack.find(".slick-slide").each(function (n, s) {
                  return s.offsetLeft - i + e(s).outerWidth() / 2 >
                    -1 * o.swipeLeft
                    ? ((t = s), !1)
                    : void 0;
                }),
                Math.abs(e(t).attr("data-slick-index") - o.currentSlide) || 1)
              : o.options.slidesToScroll
          );
        }),
        (t.prototype.goTo = t.prototype.slickGoTo =
          function (e, t) {
            this.changeSlide(
              { data: { message: "index", index: parseInt(e) } },
              t,
            );
          }),
        (t.prototype.init = function (t) {
          var i = this;
          e(i.$slider).hasClass("slick-initialized") ||
            (e(i.$slider).addClass("slick-initialized"),
            i.buildRows(),
            i.buildOut(),
            i.setProps(),
            i.startLoad(),
            i.loadSlider(),
            i.initializeEvents(),
            i.updateArrows(),
            i.updateDots()),
            t && i.$slider.trigger("init", [i]),
            !0 === i.options.accessibility && i.initADA();
        }),
        (t.prototype.initArrowEvents = function () {
          var e = this;
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow.on(
              "click.slick",
              { message: "previous" },
              e.changeSlide,
            ),
            e.$nextArrow.on("click.slick", { message: "next" }, e.changeSlide));
        }),
        (t.prototype.initDotEvents = function () {
          var t = this;
          !0 === t.options.dots &&
            t.slideCount > t.options.slidesToShow &&
            e("li", t.$dots).on(
              "click.slick",
              { message: "index" },
              t.changeSlide,
            ),
            !0 === t.options.dots &&
              !0 === t.options.pauseOnDotsHover &&
              !0 === t.options.autoplay &&
              e("li", t.$dots)
                .on("mouseenter.slick", e.proxy(t.setPaused, t, !0))
                .on("mouseleave.slick", e.proxy(t.setPaused, t, !1));
        }),
        (t.prototype.initializeEvents = function () {
          var t = this;
          t.initArrowEvents(),
            t.initDotEvents(),
            t.$list.on(
              "touchstart.slick mousedown.slick",
              { action: "start" },
              t.swipeHandler,
            ),
            t.$list.on(
              "touchmove.slick mousemove.slick",
              { action: "move" },
              t.swipeHandler,
            ),
            t.$list.on(
              "touchend.slick mouseup.slick",
              { action: "end" },
              t.swipeHandler,
            ),
            t.$list.on(
              "touchcancel.slick mouseleave.slick",
              { action: "end" },
              t.swipeHandler,
            ),
            t.$list.on("click.slick", t.clickHandler),
            e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
            t.$list.on("mouseenter.slick", e.proxy(t.setPaused, t, !0)),
            t.$list.on("mouseleave.slick", e.proxy(t.setPaused, t, !1)),
            !0 === t.options.accessibility &&
              t.$list.on("keydown.slick", t.keyHandler),
            !0 === t.options.focusOnSelect &&
              e(t.$slideTrack).children().on("click.slick", t.selectHandler),
            e(window).on(
              "orientationchange.slick.slick-" + t.instanceUid,
              e.proxy(t.orientationChange, t),
            ),
            e(window).on(
              "resize.slick.slick-" + t.instanceUid,
              e.proxy(t.resize, t),
            ),
            e("[draggable!=true]", t.$slideTrack).on(
              "dragstart",
              t.preventDefault,
            ),
            e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
            e(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition);
        }),
        (t.prototype.initUI = function () {
          var e = this;
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow.show(), e.$nextArrow.show()),
            !0 === e.options.dots &&
              e.slideCount > e.options.slidesToShow &&
              e.$dots.show(),
            !0 === e.options.autoplay && e.autoPlay();
        }),
        (t.prototype.keyHandler = function (e) {
          var t = this;
          e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
            (37 === e.keyCode && !0 === t.options.accessibility
              ? t.changeSlide({ data: { message: "previous" } })
              : 39 === e.keyCode &&
                !0 === t.options.accessibility &&
                t.changeSlide({ data: { message: "next" } }));
        }),
        (t.prototype.lazyLoad = function () {
          function t(t) {
            e("img[data-lazy]", t).each(function () {
              var t = e(this),
                i = e(this).attr("data-lazy"),
                o = document.createElement("img");
              (o.onload = function () {
                t.animate({ opacity: 0 }, 100, function () {
                  t.attr("src", i).animate({ opacity: 1 }, 200, function () {
                    t.removeAttr("data-lazy").removeClass("slick-loading");
                  });
                });
              }),
                (o.src = i);
            });
          }
          var i,
            o,
            n = this;
          !0 === n.options.centerMode
            ? !0 === n.options.infinite
              ? (o =
                  (i = n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
                  n.options.slidesToShow +
                  2)
              : ((i = Math.max(
                  0,
                  n.currentSlide - (n.options.slidesToShow / 2 + 1),
                )),
                (o = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
            : ((o =
                (i = n.options.infinite
                  ? n.options.slidesToShow + n.currentSlide
                  : n.currentSlide) + n.options.slidesToShow),
              !0 === n.options.fade &&
                (i > 0 && i--, o <= n.slideCount && o++)),
            t(n.$slider.find(".slick-slide").slice(i, o)),
            n.slideCount <= n.options.slidesToShow
              ? t(n.$slider.find(".slick-slide"))
              : n.currentSlide >= n.slideCount - n.options.slidesToShow
                ? t(
                    n.$slider
                      .find(".slick-cloned")
                      .slice(0, n.options.slidesToShow),
                  )
                : 0 === n.currentSlide &&
                  t(
                    n.$slider
                      .find(".slick-cloned")
                      .slice(-1 * n.options.slidesToShow),
                  );
        }),
        (t.prototype.loadSlider = function () {
          var e = this;
          e.setPosition(),
            e.$slideTrack.css({ opacity: 1 }),
            e.$slider.removeClass("slick-loading"),
            e.initUI(),
            "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
        }),
        (t.prototype.next = t.prototype.slickNext =
          function () {
            this.changeSlide({ data: { message: "next" } });
          }),
        (t.prototype.orientationChange = function () {
          this.checkResponsive(), this.setPosition();
        }),
        (t.prototype.pause = t.prototype.slickPause =
          function () {
            this.autoPlayClear(), (this.paused = !0);
          }),
        (t.prototype.play = t.prototype.slickPlay =
          function () {
            (this.paused = !1), this.autoPlay();
          }),
        (t.prototype.postSlide = function (e) {
          var t = this;
          t.$slider.trigger("afterChange", [t, e]),
            (t.animating = !1),
            t.setPosition(),
            (t.swipeLeft = null),
            !0 === t.options.autoplay && !1 === t.paused && t.autoPlay(),
            !0 === t.options.accessibility && t.initADA();
        }),
        (t.prototype.prev = t.prototype.slickPrev =
          function () {
            this.changeSlide({ data: { message: "previous" } });
          }),
        (t.prototype.preventDefault = function (e) {
          e.preventDefault();
        }),
        (t.prototype.progressiveLazyLoad = function () {
          var t,
            i = this;
          e("img[data-lazy]", i.$slider).length > 0 &&
            ((t = e("img[data-lazy]", i.$slider).first()).attr("src", null),
            t
              .attr("src", t.attr("data-lazy"))
              .removeClass("slick-loading")
              .load(function () {
                t.removeAttr("data-lazy"),
                  i.progressiveLazyLoad(),
                  !0 === i.options.adaptiveHeight && i.setPosition();
              })
              .error(function () {
                t.removeAttr("data-lazy"), i.progressiveLazyLoad();
              }));
        }),
        (t.prototype.refresh = function (t) {
          var i,
            o,
            n = this;
          (o = n.slideCount - n.options.slidesToShow),
            n.options.infinite ||
              (n.slideCount <= n.options.slidesToShow
                ? (n.currentSlide = 0)
                : n.currentSlide > o && (n.currentSlide = o)),
            (i = n.currentSlide),
            n.destroy(!0),
            e.extend(n, n.initials, { currentSlide: i }),
            n.init(),
            t || n.changeSlide({ data: { message: "index", index: i } }, !1);
        }),
        (t.prototype.registerBreakpoints = function () {
          var t,
            i,
            o,
            n = this,
            s = n.options.responsive || null;
          if ("array" === e.type(s) && s.length) {
            for (t in ((n.respondTo = n.options.respondTo || "window"), s))
              if (
                ((o = n.breakpoints.length - 1),
                (i = s[t].breakpoint),
                s.hasOwnProperty(t))
              ) {
                for (; o >= 0; )
                  n.breakpoints[o] &&
                    n.breakpoints[o] === i &&
                    n.breakpoints.splice(o, 1),
                    o--;
                n.breakpoints.push(i),
                  (n.breakpointSettings[i] = s[t].settings);
              }
            n.breakpoints.sort(function (e, t) {
              return n.options.mobileFirst ? e - t : t - e;
            });
          }
        }),
        (t.prototype.reinit = function () {
          var t = this;
          (t.$slides = t.$slideTrack
            .children(t.options.slide)
            .addClass("slick-slide")),
            (t.slideCount = t.$slides.length),
            t.currentSlide >= t.slideCount &&
              0 !== t.currentSlide &&
              (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
            t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
            t.registerBreakpoints(),
            t.setProps(),
            t.setupInfinite(),
            t.buildArrows(),
            t.updateArrows(),
            t.initArrowEvents(),
            t.buildDots(),
            t.updateDots(),
            t.initDotEvents(),
            t.checkResponsive(!1, !0),
            !0 === t.options.focusOnSelect &&
              e(t.$slideTrack).children().on("click.slick", t.selectHandler),
            t.setSlideClasses(0),
            t.setPosition(),
            t.$slider.trigger("reInit", [t]),
            !0 === t.options.autoplay && t.focusHandler();
        }),
        (t.prototype.resize = function () {
          var t = this;
          e(window).width() !== t.windowWidth &&
            (clearTimeout(t.windowDelay),
            (t.windowDelay = window.setTimeout(function () {
              (t.windowWidth = e(window).width()),
                t.checkResponsive(),
                t.unslicked || t.setPosition();
            }, 50)));
        }),
        (t.prototype.removeSlide = t.prototype.slickRemove =
          function (e, t, i) {
            var o = this;
            return (
              "boolean" == typeof e
                ? (e = !0 === (t = e) ? 0 : o.slideCount - 1)
                : (e = !0 === t ? --e : e),
              !(o.slideCount < 1 || 0 > e || e > o.slideCount - 1) &&
                (o.unload(),
                !0 === i
                  ? o.$slideTrack.children().remove()
                  : o.$slideTrack.children(this.options.slide).eq(e).remove(),
                (o.$slides = o.$slideTrack.children(this.options.slide)),
                o.$slideTrack.children(this.options.slide).detach(),
                o.$slideTrack.append(o.$slides),
                (o.$slidesCache = o.$slides),
                void o.reinit())
            );
          }),
        (t.prototype.setCSS = function (e) {
          var t,
            i,
            o = this,
            n = {};
          !0 === o.options.rtl && (e = -e),
            (t = "left" == o.positionProp ? Math.ceil(e) + "px" : "0px"),
            (i = "top" == o.positionProp ? Math.ceil(e) + "px" : "0px"),
            (n[o.positionProp] = e),
            !1 === o.transformsEnabled
              ? o.$slideTrack.css(n)
              : ((n = {}),
                !1 === o.cssTransitions
                  ? ((n[o.animType] = "translate(" + t + ", " + i + ")"),
                    o.$slideTrack.css(n))
                  : ((n[o.animType] = "translate3d(" + t + ", " + i + ", 0px)"),
                    o.$slideTrack.css(n)));
        }),
        (t.prototype.setDimensions = function () {
          var e = this;
          !1 === e.options.vertical
            ? !0 === e.options.centerMode &&
              e.$list.css({ padding: "0px " + e.options.centerPadding })
            : (e.$list.height(
                e.$slides.first().outerHeight(!0) * e.options.slidesToShow,
              ),
              !0 === e.options.centerMode &&
                e.$list.css({ padding: e.options.centerPadding + " 0px" })),
            (e.listWidth = e.$list.width()),
            (e.listHeight = e.$list.height()),
            !1 === e.options.vertical && !1 === e.options.variableWidth
              ? ((e.slideWidth = Math.ceil(
                  e.listWidth / e.options.slidesToShow,
                )),
                e.$slideTrack.width(
                  Math.ceil(
                    e.slideWidth *
                      e.$slideTrack.children(".slick-slide").length,
                  ),
                ))
              : !0 === e.options.variableWidth
                ? e.$slideTrack.width(5e3 * e.slideCount)
                : ((e.slideWidth = Math.ceil(e.listWidth)),
                  e.$slideTrack.height(
                    Math.ceil(
                      e.$slides.first().outerHeight(!0) *
                        e.$slideTrack.children(".slick-slide").length,
                    ),
                  ));
          var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
          !1 === e.options.variableWidth &&
            e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
        }),
        (t.prototype.setFade = function () {
          var t,
            i = this;
          i.$slides.each(function (o, n) {
            (t = i.slideWidth * o * -1),
              !0 === i.options.rtl
                ? e(n).css({
                    position: "relative",
                    right: t,
                    top: 0,
                    zIndex: i.options.zIndex - 2,
                    opacity: 0,
                  })
                : e(n).css({
                    position: "relative",
                    left: t,
                    top: 0,
                    zIndex: i.options.zIndex - 2,
                    opacity: 0,
                  });
          }),
            i.$slides
              .eq(i.currentSlide)
              .css({ zIndex: i.options.zIndex - 1, opacity: 1 });
        }),
        (t.prototype.setHeight = function () {
          var e = this;
          if (
            1 === e.options.slidesToShow &&
            !0 === e.options.adaptiveHeight &&
            !1 === e.options.vertical
          ) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.css("height", t);
          }
        }),
        (t.prototype.setOption = t.prototype.slickSetOption =
          function (t, i, o) {
            var n,
              s,
              r = this;
            if ("responsive" === t && "array" === e.type(i))
              for (s in i)
                if ("array" !== e.type(r.options.responsive))
                  r.options.responsive = [i[s]];
                else {
                  for (n = r.options.responsive.length - 1; n >= 0; )
                    r.options.responsive[n].breakpoint === i[s].breakpoint &&
                      r.options.responsive.splice(n, 1),
                      n--;
                  r.options.responsive.push(i[s]);
                }
            else r.options[t] = i;
            !0 === o && (r.unload(), r.reinit());
          }),
        (t.prototype.setPosition = function () {
          var e = this;
          e.setDimensions(),
            e.setHeight(),
            !1 === e.options.fade
              ? e.setCSS(e.getLeft(e.currentSlide))
              : e.setFade(),
            e.$slider.trigger("setPosition", [e]);
        }),
        (t.prototype.setProps = function () {
          var e = this,
            t = document.body.style;
          (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
            "top" === e.positionProp
              ? e.$slider.addClass("slick-vertical")
              : e.$slider.removeClass("slick-vertical"),
            (void 0 !== t.WebkitTransition ||
              void 0 !== t.MozTransition ||
              void 0 !== t.msTransition) &&
              !0 === e.options.useCSS &&
              (e.cssTransitions = !0),
            e.options.fade &&
              ("number" == typeof e.options.zIndex
                ? e.options.zIndex < 3 && (e.options.zIndex = 3)
                : (e.options.zIndex = e.defaults.zIndex)),
            void 0 !== t.OTransform &&
              ((e.animType = "OTransform"),
              (e.transformType = "-o-transform"),
              (e.transitionType = "OTransition"),
              void 0 === t.perspectiveProperty &&
                void 0 === t.webkitPerspective &&
                (e.animType = !1)),
            void 0 !== t.MozTransform &&
              ((e.animType = "MozTransform"),
              (e.transformType = "-moz-transform"),
              (e.transitionType = "MozTransition"),
              void 0 === t.perspectiveProperty &&
                void 0 === t.MozPerspective &&
                (e.animType = !1)),
            void 0 !== t.webkitTransform &&
              ((e.animType = "webkitTransform"),
              (e.transformType = "-webkit-transform"),
              (e.transitionType = "webkitTransition"),
              void 0 === t.perspectiveProperty &&
                void 0 === t.webkitPerspective &&
                (e.animType = !1)),
            void 0 !== t.msTransform &&
              ((e.animType = "msTransform"),
              (e.transformType = "-ms-transform"),
              (e.transitionType = "msTransition"),
              void 0 === t.msTransform && (e.animType = !1)),
            void 0 !== t.transform &&
              !1 !== e.animType &&
              ((e.animType = "transform"),
              (e.transformType = "transform"),
              (e.transitionType = "transition")),
            (e.transformsEnabled =
              e.options.useTransform &&
              null !== e.animType &&
              !1 !== e.animType);
        }),
        (t.prototype.setSlideClasses = function (e) {
          var t,
            i,
            o,
            n,
            s = this;
          (i = s.$slider
            .find(".slick-slide")
            .removeClass("slick-active slick-center slick-current")
            .attr("aria-hidden", "true")),
            s.$slides.eq(e).addClass("slick-current"),
            !0 === s.options.centerMode
              ? ((t = Math.floor(s.options.slidesToShow / 2)),
                !0 === s.options.infinite &&
                  (e >= t && e <= s.slideCount - 1 - t
                    ? s.$slides
                        .slice(e - t, e + t + 1)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false")
                    : ((o = s.options.slidesToShow + e),
                      i
                        .slice(o - t + 1, o + t + 2)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false")),
                  0 === e
                    ? i
                        .eq(i.length - 1 - s.options.slidesToShow)
                        .addClass("slick-center")
                    : e === s.slideCount - 1 &&
                      i.eq(s.options.slidesToShow).addClass("slick-center")),
                s.$slides.eq(e).addClass("slick-center"))
              : e >= 0 && e <= s.slideCount - s.options.slidesToShow
                ? s.$slides
                    .slice(e, e + s.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : i.length <= s.options.slidesToShow
                  ? i.addClass("slick-active").attr("aria-hidden", "false")
                  : ((n = s.slideCount % s.options.slidesToShow),
                    (o =
                      !0 === s.options.infinite
                        ? s.options.slidesToShow + e
                        : e),
                    s.options.slidesToShow == s.options.slidesToScroll &&
                    s.slideCount - e < s.options.slidesToShow
                      ? i
                          .slice(o - (s.options.slidesToShow - n), o + n)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")
                      : i
                          .slice(o, o + s.options.slidesToShow)
                          .addClass("slick-active")
                          .attr("aria-hidden", "false")),
            "ondemand" === s.options.lazyLoad && s.lazyLoad();
        }),
        (t.prototype.setupInfinite = function () {
          var t,
            i,
            o,
            n = this;
          if (
            (!0 === n.options.fade && (n.options.centerMode = !1),
            !0 === n.options.infinite &&
              !1 === n.options.fade &&
              ((i = null), n.slideCount > n.options.slidesToShow))
          ) {
            for (
              o =
                !0 === n.options.centerMode
                  ? n.options.slidesToShow + 1
                  : n.options.slidesToShow,
                t = n.slideCount;
              t > n.slideCount - o;
              t -= 1
            )
              (i = t - 1),
                e(n.$slides[i])
                  .clone(!0)
                  .attr("id", "")
                  .attr("data-slick-index", i - n.slideCount)
                  .prependTo(n.$slideTrack)
                  .addClass("slick-cloned");
            for (t = 0; o > t; t += 1)
              (i = t),
                e(n.$slides[i])
                  .clone(!0)
                  .attr("id", "")
                  .attr("data-slick-index", i + n.slideCount)
                  .appendTo(n.$slideTrack)
                  .addClass("slick-cloned");
            n.$slideTrack
              .find(".slick-cloned")
              .find("[id]")
              .each(function () {
                e(this).attr("id", "");
              });
          }
        }),
        (t.prototype.setPaused = function (e) {
          var t = this;
          !0 === t.options.autoplay &&
            !0 === t.options.pauseOnHover &&
            ((t.paused = e), e ? t.autoPlayClear() : t.autoPlay());
        }),
        (t.prototype.selectHandler = function (t) {
          var i = this,
            o = e(t.target).is(".slick-slide")
              ? e(t.target)
              : e(t.target).parents(".slick-slide"),
            n = parseInt(o.attr("data-slick-index"));
          return (
            n || (n = 0),
            i.slideCount <= i.options.slidesToShow
              ? (i.setSlideClasses(n), void i.asNavFor(n))
              : void i.slideHandler(n)
          );
        }),
        (t.prototype.slideHandler = function (e, t, i) {
          var o,
            n,
            s,
            r,
            a = null,
            l = this;
          return (
            (t = t || !1),
            (!0 === l.animating && !0 === l.options.waitForAnimate) ||
            (!0 === l.options.fade && l.currentSlide === e) ||
            l.slideCount <= l.options.slidesToShow
              ? void 0
              : (!1 === t && l.asNavFor(e),
                (o = e),
                (a = l.getLeft(o)),
                (r = l.getLeft(l.currentSlide)),
                (l.currentLeft = null === l.swipeLeft ? r : l.swipeLeft),
                !1 === l.options.infinite &&
                !1 === l.options.centerMode &&
                (0 > e || e > l.getDotCount() * l.options.slidesToScroll)
                  ? void (
                      !1 === l.options.fade &&
                      ((o = l.currentSlide),
                      !0 !== i
                        ? l.animateSlide(r, function () {
                            l.postSlide(o);
                          })
                        : l.postSlide(o))
                    )
                  : !1 === l.options.infinite &&
                      !0 === l.options.centerMode &&
                      (0 > e || e > l.slideCount - l.options.slidesToScroll)
                    ? void (
                        !1 === l.options.fade &&
                        ((o = l.currentSlide),
                        !0 !== i
                          ? l.animateSlide(r, function () {
                              l.postSlide(o);
                            })
                          : l.postSlide(o))
                      )
                    : (!0 === l.options.autoplay &&
                        clearInterval(l.autoPlayTimer),
                      (n =
                        0 > o
                          ? l.slideCount % l.options.slidesToScroll != 0
                            ? l.slideCount -
                              (l.slideCount % l.options.slidesToScroll)
                            : l.slideCount + o
                          : o >= l.slideCount
                            ? l.slideCount % l.options.slidesToScroll != 0
                              ? 0
                              : o - l.slideCount
                            : o),
                      (l.animating = !0),
                      l.$slider.trigger("beforeChange", [l, l.currentSlide, n]),
                      (s = l.currentSlide),
                      (l.currentSlide = n),
                      l.setSlideClasses(l.currentSlide),
                      l.updateDots(),
                      l.updateArrows(),
                      !0 === l.options.fade
                        ? (!0 !== i
                            ? (l.fadeSlideOut(s),
                              l.fadeSlide(n, function () {
                                l.postSlide(n);
                              }))
                            : l.postSlide(n),
                          void l.animateHeight())
                        : void (!0 !== i
                            ? l.animateSlide(a, function () {
                                l.postSlide(n);
                              })
                            : l.postSlide(n))))
          );
        }),
        (t.prototype.startLoad = function () {
          var e = this;
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow.hide(), e.$nextArrow.hide()),
            !0 === e.options.dots &&
              e.slideCount > e.options.slidesToShow &&
              e.$dots.hide(),
            e.$slider.addClass("slick-loading");
        }),
        (t.prototype.swipeDirection = function () {
          var e,
            t,
            i,
            o,
            n = this;
          return (
            (e = n.touchObject.startX - n.touchObject.curX),
            (t = n.touchObject.startY - n.touchObject.curY),
            (i = Math.atan2(t, e)),
            0 > (o = Math.round((180 * i) / Math.PI)) &&
              (o = 360 - Math.abs(o)),
            45 >= o && o >= 0
              ? !1 === n.options.rtl
                ? "left"
                : "right"
              : 360 >= o && o >= 315
                ? !1 === n.options.rtl
                  ? "left"
                  : "right"
                : o >= 135 && 225 >= o
                  ? !1 === n.options.rtl
                    ? "right"
                    : "left"
                  : !0 === n.options.verticalSwiping
                    ? o >= 35 && 135 >= o
                      ? "left"
                      : "right"
                    : "vertical"
          );
        }),
        (t.prototype.swipeEnd = function (e) {
          var t,
            i = this;
          if (
            ((i.dragging = !1),
            (i.shouldClick = !(i.touchObject.swipeLength > 10)),
            void 0 === i.touchObject.curX)
          )
            return !1;
          if (
            (!0 === i.touchObject.edgeHit &&
              i.$slider.trigger("edge", [i, i.swipeDirection()]),
            i.touchObject.swipeLength >= i.touchObject.minSwipe)
          )
            switch (i.swipeDirection()) {
              case "left":
                (t = i.options.swipeToSlide
                  ? i.checkNavigable(i.currentSlide + i.getSlideCount())
                  : i.currentSlide + i.getSlideCount()),
                  i.slideHandler(t),
                  (i.currentDirection = 0),
                  (i.touchObject = {}),
                  i.$slider.trigger("swipe", [i, "left"]);
                break;
              case "right":
                (t = i.options.swipeToSlide
                  ? i.checkNavigable(i.currentSlide - i.getSlideCount())
                  : i.currentSlide - i.getSlideCount()),
                  i.slideHandler(t),
                  (i.currentDirection = 1),
                  (i.touchObject = {}),
                  i.$slider.trigger("swipe", [i, "right"]);
            }
          else
            i.touchObject.startX !== i.touchObject.curX &&
              (i.slideHandler(i.currentSlide), (i.touchObject = {}));
        }),
        (t.prototype.swipeHandler = function (e) {
          var t = this;
          if (
            !(
              !1 === t.options.swipe ||
              ("ontouchend" in document && !1 === t.options.swipe) ||
              (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))
            )
          )
            switch (
              ((t.touchObject.fingerCount =
                e.originalEvent && void 0 !== e.originalEvent.touches
                  ? e.originalEvent.touches.length
                  : 1),
              (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
              !0 === t.options.verticalSwiping &&
                (t.touchObject.minSwipe =
                  t.listHeight / t.options.touchThreshold),
              e.data.action)
            ) {
              case "start":
                t.swipeStart(e);
                break;
              case "move":
                t.swipeMove(e);
                break;
              case "end":
                t.swipeEnd(e);
            }
        }),
        (t.prototype.swipeMove = function (e) {
          var t,
            i,
            o,
            n,
            s,
            r = this;
          return (
            (s = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
            !(!r.dragging || (s && 1 !== s.length)) &&
              ((t = r.getLeft(r.currentSlide)),
              (r.touchObject.curX = void 0 !== s ? s[0].pageX : e.clientX),
              (r.touchObject.curY = void 0 !== s ? s[0].pageY : e.clientY),
              (r.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(r.touchObject.curX - r.touchObject.startX, 2),
                ),
              )),
              !0 === r.options.verticalSwiping &&
                (r.touchObject.swipeLength = Math.round(
                  Math.sqrt(
                    Math.pow(r.touchObject.curY - r.touchObject.startY, 2),
                  ),
                )),
              "vertical" !== (i = r.swipeDirection())
                ? (void 0 !== e.originalEvent &&
                    r.touchObject.swipeLength > 4 &&
                    e.preventDefault(),
                  (n =
                    (!1 === r.options.rtl ? 1 : -1) *
                    (r.touchObject.curX > r.touchObject.startX ? 1 : -1)),
                  !0 === r.options.verticalSwiping &&
                    (n = r.touchObject.curY > r.touchObject.startY ? 1 : -1),
                  (o = r.touchObject.swipeLength),
                  (r.touchObject.edgeHit = !1),
                  !1 === r.options.infinite &&
                    ((0 === r.currentSlide && "right" === i) ||
                      (r.currentSlide >= r.getDotCount() && "left" === i)) &&
                    ((o = r.touchObject.swipeLength * r.options.edgeFriction),
                    (r.touchObject.edgeHit = !0)),
                  !1 === r.options.vertical
                    ? (r.swipeLeft = t + o * n)
                    : (r.swipeLeft =
                        t + o * (r.$list.height() / r.listWidth) * n),
                  !0 === r.options.verticalSwiping && (r.swipeLeft = t + o * n),
                  !0 !== r.options.fade &&
                    !1 !== r.options.touchMove &&
                    (!0 === r.animating
                      ? ((r.swipeLeft = null), !1)
                      : void r.setCSS(r.swipeLeft)))
                : void 0)
          );
        }),
        (t.prototype.swipeStart = function (e) {
          var t,
            i = this;
          return 1 !== i.touchObject.fingerCount ||
            i.slideCount <= i.options.slidesToShow
            ? ((i.touchObject = {}), !1)
            : (void 0 !== e.originalEvent &&
                void 0 !== e.originalEvent.touches &&
                (t = e.originalEvent.touches[0]),
              (i.touchObject.startX = i.touchObject.curX =
                void 0 !== t ? t.pageX : e.clientX),
              (i.touchObject.startY = i.touchObject.curY =
                void 0 !== t ? t.pageY : e.clientY),
              void (i.dragging = !0));
        }),
        (t.prototype.unfilterSlides = t.prototype.slickUnfilter =
          function () {
            var e = this;
            null !== e.$slidesCache &&
              (e.unload(),
              e.$slideTrack.children(this.options.slide).detach(),
              e.$slidesCache.appendTo(e.$slideTrack),
              e.reinit());
          }),
        (t.prototype.unload = function () {
          var t = this;
          e(".slick-cloned", t.$slider).remove(),
            t.$dots && t.$dots.remove(),
            t.$prevArrow &&
              t.htmlExpr.test(t.options.prevArrow) &&
              t.$prevArrow.remove(),
            t.$nextArrow &&
              t.htmlExpr.test(t.options.nextArrow) &&
              t.$nextArrow.remove(),
            t.$slides
              .removeClass(
                "slick-slide slick-active slick-visible slick-current",
              )
              .attr("aria-hidden", "true")
              .css("width", "");
        }),
        (t.prototype.unslick = function (e) {
          var t = this;
          t.$slider.trigger("unslick", [t, e]), t.destroy();
        }),
        (t.prototype.updateArrows = function () {
          var e = this;
          Math.floor(e.options.slidesToShow / 2),
            !0 === e.options.arrows &&
              e.slideCount > e.options.slidesToShow &&
              !e.options.infinite &&
              (e.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"),
              e.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"),
              0 === e.currentSlide
                ? (e.$prevArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"),
                  e.$nextArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false"))
                : e.currentSlide >= e.slideCount - e.options.slidesToShow &&
                    !1 === e.options.centerMode
                  ? (e.$nextArrow
                      .addClass("slick-disabled")
                      .attr("aria-disabled", "true"),
                    e.$prevArrow
                      .removeClass("slick-disabled")
                      .attr("aria-disabled", "false"))
                  : e.currentSlide >= e.slideCount - 1 &&
                    !0 === e.options.centerMode &&
                    (e.$nextArrow
                      .addClass("slick-disabled")
                      .attr("aria-disabled", "true"),
                    e.$prevArrow
                      .removeClass("slick-disabled")
                      .attr("aria-disabled", "false")));
        }),
        (t.prototype.updateDots = function () {
          var e = this;
          null !== e.$dots &&
            (e.$dots
              .find("li")
              .removeClass("slick-active")
              .attr("aria-hidden", "true"),
            e.$dots
              .find("li")
              .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
              .addClass("slick-active")
              .attr("aria-hidden", "false"));
        }),
        (t.prototype.visibility = function () {
          var e = this;
          document[e.hidden]
            ? ((e.paused = !0), e.autoPlayClear())
            : !0 === e.options.autoplay && ((e.paused = !1), e.autoPlay());
        }),
        (t.prototype.initADA = function () {
          var t = this;
          t.$slides
            .add(t.$slideTrack.find(".slick-cloned"))
            .attr({ "aria-hidden": "true", tabindex: "-1" })
            .find("a, input, button, select")
            .attr({ tabindex: "-1" }),
            t.$slideTrack.attr("role", "listbox"),
            t.$slides
              .not(t.$slideTrack.find(".slick-cloned"))
              .each(function (i) {
                e(this).attr({
                  role: "option",
                  "aria-describedby": "slick-slide" + t.instanceUid + i,
                });
              }),
            null !== t.$dots &&
              t.$dots
                .attr("role", "tablist")
                .find("li")
                .each(function (i) {
                  e(this).attr({
                    role: "presentation",
                    "aria-selected": "false",
                    "aria-controls": "navigation" + t.instanceUid + i,
                    id: "slick-slide" + t.instanceUid + i,
                  });
                })
                .first()
                .attr("aria-selected", "true")
                .end()
                .find("button")
                .attr("role", "button")
                .end()
                .closest("div")
                .attr("role", "toolbar"),
            t.activateADA();
        }),
        (t.prototype.activateADA = function () {
          this.$slideTrack
            .find(".slick-active")
            .attr({ "aria-hidden": "false" })
            .find("a, input, button, select")
            .attr({ tabindex: "0" });
        }),
        (t.prototype.focusHandler = function () {
          var t = this;
          t.$slider.on("focus.slick blur.slick", "*", function (i) {
            i.stopImmediatePropagation();
            var o = e(this);
            setTimeout(function () {
              t.isPlay &&
                (o.is(":focus")
                  ? (t.autoPlayClear(), (t.paused = !0))
                  : ((t.paused = !1), t.autoPlay()));
            }, 0);
          });
        }),
        (e.fn.slick = function () {
          var e,
            i,
            o = this,
            n = arguments[0],
            s = Array.prototype.slice.call(arguments, 1),
            r = o.length;
          for (e = 0; r > e; e++)
            if (
              ("object" == typeof n || void 0 === n
                ? (o[e].slick = new t(o[e], n))
                : (i = o[e].slick[n].apply(o[e].slick, s)),
              void 0 !== i)
            )
              return i;
          return o;
        });
    }),
    (function (e, t, i) {
      function o(i, o, n) {
        var s = t.createElement(i);
        return o && (s.id = G + o), n && (s.style.cssText = n), e(s);
      }
      function n() {
        return i.innerHeight ? i.innerHeight : e(i).height();
      }
      function s(t, i) {
        i !== Object(i) && (i = {}),
          (this.cache = {}),
          (this.el = t),
          (this.value = function (t) {
            var o;
            return (
              void 0 === this.cache[t] &&
                (void 0 !== (o = e(this.el).attr("data-cbox-" + t))
                  ? (this.cache[t] = o)
                  : void 0 !== i[t]
                    ? (this.cache[t] = i[t])
                    : void 0 !== K[t] && (this.cache[t] = K[t])),
              this.cache[t]
            );
          }),
          (this.get = function (t) {
            var i = this.value(t);
            return e.isFunction(i) ? i.call(this.el, this) : i;
          });
      }
      function r(e) {
        var t = x.length,
          i = (F + e) % t;
        return 0 > i ? t + i : i;
      }
      function a(e, t) {
        return Math.round(
          (/%/.test(e) ? ("x" === t ? C.width() : n()) / 100 : 1) *
            parseInt(e, 10),
        );
      }
      function l(e, t) {
        return e.get("photo") || e.get("photoRegex").test(t);
      }
      function d(e, t) {
        return e.get("retinaUrl") && i.devicePixelRatio > 1
          ? t.replace(e.get("photoRegex"), e.get("retinaSuffix"))
          : t;
      }
      function c(e) {
        "contains" in y[0] &&
          !y[0].contains(e.target) &&
          e.target !== m[0] &&
          (e.stopPropagation(), y.focus());
      }
      function u(e) {
        u.str !== e && (y.add(m).removeClass(u.str).addClass(e), (u.str = e));
      }
      function p(i) {
        e(t).trigger(i), re.triggerHandler(i);
      }
      function h(i) {
        var n;
        if (!X) {
          if (
            ((n = e(i).data(Z)),
            (function (t) {
              (F = 0),
                t && !1 !== t && "nofollow" !== t
                  ? ((x = e("." + J).filter(function () {
                      return new s(this, e.data(this, Z)).get("rel") === t;
                    })),
                    -1 === (F = x.index(N.el)) &&
                      ((x = x.add(N.el)), (F = x.length - 1)))
                  : (x = e(N.el));
            })((N = new s(i, n)).get("rel")),
            !B)
          ) {
            (B = U = !0),
              u(N.get("className")),
              y.css({ visibility: "hidden", display: "block", opacity: "" }),
              ($ = o(
                ae,
                "LoadedContent",
                "width:0; height:0; overflow:hidden; visibility:hidden",
              )),
              b.css({ width: "", height: "" }).append($),
              (_ = k.height() + z.height() + b.outerHeight(!0) - b.height()),
              (W = S.width() + T.width() + b.outerWidth(!0) - b.width()),
              (D = $.outerHeight(!0)),
              (R = $.outerWidth(!0));
            var r = a(N.get("initialWidth"), "x"),
              l = a(N.get("initialHeight"), "y"),
              d = N.get("maxWidth"),
              h = N.get("maxHeight");
            (N.w = (!1 !== d ? Math.min(r, a(d, "x")) : r) - R - W),
              (N.h = (!1 !== h ? Math.min(l, a(h, "y")) : l) - D - _),
              $.css({ width: "", height: N.h }),
              V.position(),
              p(ee),
              N.get("onOpen"),
              I.add(P).hide(),
              y.focus(),
              N.get("trapFocus") &&
                t.addEventListener &&
                (t.addEventListener("focus", c, !0),
                re.one(ne, function () {
                  t.removeEventListener("focus", c, !0);
                })),
              N.get("returnFocus") &&
                re.one(ne, function () {
                  e(N.el).focus();
                });
          }
          var f = parseFloat(N.get("opacity"));
          m
            .css({
              opacity: f == f ? f : "",
              cursor: N.get("overlayClose") ? "pointer" : "",
              visibility: "visible",
            })
            .show(),
            N.get("closeButton")
              ? j.html(N.get("close")).appendTo(b)
              : j.appendTo("<div/>"),
            v();
        }
      }
      function f() {
        y ||
          ((Q = !1),
          (C = e(i)),
          (y = o(ae)
            .attr({
              id: Z,
              class: !1 === e.support.opacity ? G + "IE" : "",
              role: "dialog",
              tabindex: "-1",
            })
            .hide()),
          (m = o(ae, "Overlay").hide()),
          (E = e([o(ae, "LoadingOverlay")[0], o(ae, "LoadingGraphic")[0]])),
          (w = o(ae, "Wrapper")),
          (b = o(ae, "Content").append(
            (P = o(ae, "Title")),
            (L = o(ae, "Current")),
            (H = e('<button type="button"/>').attr({ id: G + "Previous" })),
            (M = e('<button type="button"/>').attr({ id: G + "Next" })),
            (O = o("button", "Slideshow")),
            E,
          )),
          (j = e('<button type="button"/>').attr({ id: G + "Close" })),
          w
            .append(
              o(ae).append(
                o(ae, "TopLeft"),
                (k = o(ae, "TopCenter")),
                o(ae, "TopRight"),
              ),
              o(ae, !1, "clear:left").append(
                (S = o(ae, "MiddleLeft")),
                b,
                (T = o(ae, "MiddleRight")),
              ),
              o(ae, !1, "clear:left").append(
                o(ae, "BottomLeft"),
                (z = o(ae, "BottomCenter")),
                o(ae, "BottomRight"),
              ),
            )
            .find("div div")
            .css({ float: "left" }),
          (A = o(
            ae,
            !1,
            "position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;",
          )),
          (I = M.add(H).add(L).add(O))),
          t.body && !y.parent().length && e(t.body).append(m, y.append(w, A));
      }
      function g() {
        function i(e) {
          e.which > 1 ||
            e.shiftKey ||
            e.altKey ||
            e.metaKey ||
            e.ctrlKey ||
            (e.preventDefault(), h(this));
        }
        return (
          !!y &&
          (Q ||
            ((Q = !0),
            M.click(function () {
              V.next();
            }),
            H.click(function () {
              V.prev();
            }),
            j.click(function () {
              V.close();
            }),
            m.click(function () {
              N.get("overlayClose") && V.close();
            }),
            e(t).bind("keydown." + G, function (e) {
              var t = e.keyCode;
              B &&
                N.get("escKey") &&
                27 === t &&
                (e.preventDefault(), V.close()),
                B &&
                  N.get("arrowKey") &&
                  x[1] &&
                  !e.altKey &&
                  (37 === t
                    ? (e.preventDefault(), H.click())
                    : 39 === t && (e.preventDefault(), M.click()));
            }),
            e.isFunction(e.fn.on)
              ? e(t).on("click." + G, "." + J, i)
              : e("." + J).live("click." + G, i)),
          !0)
        );
      }
      function v() {
        var t,
          n,
          s,
          r = V.prep,
          c = ++le;
        if (
          ((U = !0),
          (q = !1),
          p(se),
          p(te),
          N.get("onLoad"),
          (N.h = N.get("height")
            ? a(N.get("height"), "y") - D - _
            : N.get("innerHeight") && a(N.get("innerHeight"), "y")),
          (N.w = N.get("width")
            ? a(N.get("width"), "x") - R - W
            : N.get("innerWidth") && a(N.get("innerWidth"), "x")),
          (N.mw = N.w),
          (N.mh = N.h),
          N.get("maxWidth") &&
            ((N.mw = a(N.get("maxWidth"), "x") - R - W),
            (N.mw = N.w && N.w < N.mw ? N.w : N.mw)),
          N.get("maxHeight") &&
            ((N.mh = a(N.get("maxHeight"), "y") - D - _),
            (N.mh = N.h && N.h < N.mh ? N.h : N.mh)),
          (t = N.get("href")),
          (Y = setTimeout(function () {
            E.show();
          }, 100)),
          N.get("inline"))
        ) {
          var u = e(t);
          (s = e("<div>").hide().insertBefore(u)),
            re.one(se, function () {
              s.replaceWith(u);
            }),
            r(u);
        } else
          N.get("iframe")
            ? r(" ")
            : N.get("html")
              ? r(N.get("html"))
              : l(N, t)
                ? ((t = d(N, t)),
                  (q = N.get("createImg")),
                  e(q)
                    .addClass(G + "Photo")
                    .bind("error." + G, function () {
                      r(o(ae, "Error").html(N.get("imgError")));
                    })
                    .one("load", function () {
                      c === le &&
                        setTimeout(function () {
                          var t;
                          N.get("retinaImage") &&
                            i.devicePixelRatio > 1 &&
                            ((q.height = q.height / i.devicePixelRatio),
                            (q.width = q.width / i.devicePixelRatio)),
                            N.get("scalePhotos") &&
                              ((n = function () {
                                (q.height -= q.height * t),
                                  (q.width -= q.width * t);
                              }),
                              N.mw &&
                                q.width > N.mw &&
                                ((t = (q.width - N.mw) / q.width), n()),
                              N.mh &&
                                q.height > N.mh &&
                                ((t = (q.height - N.mh) / q.height), n())),
                            (N.h || N.get("minHeight")) &&
                              (q.style.marginTop =
                                Math.max(
                                  (N.h || N.get("minHeight")) - q.height,
                                  0,
                                ) /
                                  2 +
                                "px"),
                            x[1] &&
                              (N.get("loop") || x[F + 1]) &&
                              ((q.style.cursor = "pointer"),
                              e(q).bind("click." + G, function () {
                                V.next();
                              })),
                            (q.style.width = q.width + "px"),
                            (q.style.height = q.height + "px"),
                            r(q);
                        }, 1);
                    }),
                  (q.src = t))
                : t &&
                  A.load(t, N.get("data"), function (t, i) {
                    c === le &&
                      r(
                        "error" === i
                          ? o(ae, "Error").html(N.get("xhrError"))
                          : e(this).contents(),
                      );
                  });
      }
      var m,
        y,
        w,
        b,
        k,
        S,
        T,
        z,
        x,
        C,
        $,
        A,
        E,
        P,
        L,
        O,
        M,
        H,
        j,
        I,
        N,
        _,
        W,
        D,
        R,
        F,
        q,
        B,
        U,
        X,
        Y,
        V,
        Q,
        K = {
          html: !1,
          photo: !1,
          iframe: !1,
          inline: !1,
          transition: "elastic",
          speed: 300,
          fadeOut: 300,
          width: !1,
          initialWidth: "600",
          innerWidth: !1,
          maxWidth: !1,
          minWidth: !1,
          height: !1,
          initialHeight: "450",
          innerHeight: !1,
          maxHeight: !1,
          minHeight: !1,
          scalePhotos: !0,
          scrolling: !0,
          opacity: 0.9,
          preloading: !0,
          className: !1,
          overlayClose: !0,
          escKey: !0,
          arrowKey: !0,
          top: !1,
          bottom: !1,
          left: !1,
          right: !1,
          fixed: !1,
          data: void 0,
          closeButton: !0,
          fastIframe: !0,
          open: !1,
          reposition: !0,
          loop: !0,
          slideshow: !1,
          slideshowAuto: !0,
          slideshowSpeed: 2500,
          slideshowStart: "start slideshow",
          slideshowStop: "stop slideshow",
          photoRegex:
            /\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,
          retinaImage: !1,
          retinaUrl: !1,
          retinaSuffix: "@2x.$1",
          current: "image {current} of {total}",
          previous: "previous",
          next: "next",
          close: "close",
          xhrError: "This content failed to load.",
          imgError: "This image failed to load.",
          returnFocus: !0,
          trapFocus: !0,
          onOpen: !1,
          onLoad: !1,
          onComplete: !1,
          onCleanup: !1,
          onClosed: !1,
          rel: function () {
            return this.rel;
          },
          href: function () {
            return e(this).attr("href");
          },
          title: function () {
            return this.title;
          },
          createImg: function () {
            var t = new Image(),
              i = e(this).data("cbox-img-attrs");
            return (
              "object" == typeof i &&
                e.each(i, function (e, i) {
                  t[e] = i;
                }),
              t
            );
          },
          createIframe: function () {
            var i = t.createElement("iframe"),
              o = e(this).data("cbox-iframe-attrs");
            return (
              "object" == typeof o &&
                e.each(o, function (e, t) {
                  i[e] = t;
                }),
              "frameBorder" in i && (i.frameBorder = 0),
              "allowTransparency" in i && (i.allowTransparency = "true"),
              (i.name = new Date().getTime()),
              (i.allowFullScreen = !0),
              i
            );
          },
        },
        Z = "colorbox",
        G = "cbox",
        J = G + "Element",
        ee = G + "_open",
        te = G + "_load",
        ie = G + "_complete",
        oe = G + "_cleanup",
        ne = G + "_closed",
        se = G + "_purge",
        re = e("<a/>"),
        ae = "div",
        le = 0,
        de = {},
        ce = (function () {
          function e() {
            clearTimeout(r);
          }
          function t() {
            (N.get("loop") || x[F + 1]) &&
              (e(), (r = setTimeout(V.next, N.get("slideshowSpeed"))));
          }
          function i() {
            O.html(N.get("slideshowStop")).unbind(l).one(l, o),
              re.bind(ie, t).bind(te, e),
              y.removeClass(a + "off").addClass(a + "on");
          }
          function o() {
            e(),
              re.unbind(ie, t).unbind(te, e),
              O.html(N.get("slideshowStart"))
                .unbind(l)
                .one(l, function () {
                  V.next(), i();
                }),
              y.removeClass(a + "on").addClass(a + "off");
          }
          function n() {
            (s = !1),
              O.hide(),
              e(),
              re.unbind(ie, t).unbind(te, e),
              y.removeClass(a + "off " + a + "on");
          }
          var s,
            r,
            a = G + "Slideshow_",
            l = "click." + G;
          return function () {
            s
              ? N.get("slideshow") || (re.unbind(oe, n), n())
              : N.get("slideshow") &&
                x[1] &&
                ((s = !0),
                re.one(oe, n),
                N.get("slideshowAuto") ? i() : o(),
                O.show());
          };
        })();
      e[Z] ||
        (e(f),
        ((V =
          e.fn[Z] =
          e[Z] =
            function (t, i) {
              var o = this;
              return (
                (t = t || {}),
                e.isFunction(o) && ((o = e("<a/>")), (t.open = !0)),
                o[0]
                  ? (f(),
                    g() &&
                      (i && (t.onComplete = i),
                      o
                        .each(function () {
                          var i = e.data(this, Z) || {};
                          e.data(this, Z, e.extend(i, t));
                        })
                        .addClass(J),
                      new s(o[0], t).get("open") && h(o[0])),
                    o)
                  : o
              );
            }).position = function (t, i) {
          function o() {
            (k[0].style.width =
              z[0].style.width =
              b[0].style.width =
                parseInt(y[0].style.width, 10) - W + "px"),
              (b[0].style.height =
                S[0].style.height =
                T[0].style.height =
                  parseInt(y[0].style.height, 10) - _ + "px");
          }
          var s,
            r,
            l,
            d = 0,
            c = 0,
            u = y.offset();
          if (
            (C.unbind("resize." + G),
            y.css({ top: -9e4, left: -9e4 }),
            (r = C.scrollTop()),
            (l = C.scrollLeft()),
            N.get("fixed")
              ? ((u.top -= r), (u.left -= l), y.css({ position: "fixed" }))
              : ((d = r), (c = l), y.css({ position: "absolute" })),
            (c +=
              !1 !== N.get("right")
                ? Math.max(C.width() - N.w - R - W - a(N.get("right"), "x"), 0)
                : !1 !== N.get("left")
                  ? a(N.get("left"), "x")
                  : Math.round(Math.max(C.width() - N.w - R - W, 0) / 2)),
            (d +=
              !1 !== N.get("bottom")
                ? Math.max(n() - N.h - D - _ - a(N.get("bottom"), "y"), 0)
                : !1 !== N.get("top")
                  ? a(N.get("top"), "y")
                  : Math.round(Math.max(n() - N.h - D - _, 0) / 2)),
            y.css({ top: u.top, left: u.left, visibility: "visible" }),
            (w[0].style.width = w[0].style.height = "9999px"),
            (s = { width: N.w + R + W, height: N.h + D + _, top: d, left: c }),
            t)
          ) {
            var p = 0;
            e.each(s, function (e) {
              return s[e] !== de[e] ? void (p = t) : void 0;
            }),
              (t = p);
          }
          (de = s),
            t || y.css(s),
            y.dequeue().animate(s, {
              duration: t || 0,
              complete: function () {
                o(),
                  (U = !1),
                  (w[0].style.width = N.w + R + W + "px"),
                  (w[0].style.height = N.h + D + _ + "px"),
                  N.get("reposition") &&
                    setTimeout(function () {
                      C.bind("resize." + G, V.position);
                    }, 1),
                  e.isFunction(i) && i();
              },
              step: o,
            });
        }),
        (V.resize = function (e) {
          var t;
          B &&
            ((e = e || {}).width && (N.w = a(e.width, "x") - R - W),
            e.innerWidth && (N.w = a(e.innerWidth, "x")),
            $.css({ width: N.w }),
            e.height && (N.h = a(e.height, "y") - D - _),
            e.innerHeight && (N.h = a(e.innerHeight, "y")),
            e.innerHeight ||
              e.height ||
              ((t = $.scrollTop()),
              $.css({ height: "auto" }),
              (N.h = $.height())),
            $.css({ height: N.h }),
            t && $.scrollTop(t),
            V.position("none" === N.get("transition") ? 0 : N.get("speed")));
        }),
        (V.prep = function (i) {
          if (B) {
            var n,
              c = "none" === N.get("transition") ? 0 : N.get("speed");
            $.remove(),
              ($ = o(ae, "LoadedContent").append(i))
                .hide()
                .appendTo(A.show())
                .css({
                  width:
                    ((N.w = N.w || $.width()),
                    N.get("minWidth") &&
                      N.w < N.get("minWidth") &&
                      (N.w = a(N.get("minWidth"), "x")),
                    (N.w = N.mw && N.mw < N.w ? N.mw : N.w),
                    N.w),
                  overflow: N.get("scrolling") ? "auto" : "hidden",
                })
                .css({
                  height:
                    ((N.h = N.h || $.height()),
                    N.get("minHeight") &&
                      N.h < N.get("minHeight") &&
                      (N.h = a(N.get("minHeight"), "y")),
                    (N.h = N.mh && N.mh < N.h ? N.mh : N.h),
                    N.h),
                })
                .prependTo(b),
              A.hide(),
              e(q).css({ float: "none" }),
              u(N.get("className")),
              (n = function () {
                function i() {
                  !1 === e.support.opacity &&
                    y[0].style.removeAttribute("filter");
                }
                var o,
                  n,
                  a = x.length;
                B &&
                  ((n = function () {
                    clearTimeout(Y), E.hide(), p(ie), N.get("onComplete");
                  }),
                  P.html(N.get("title")).show(),
                  $.show(),
                  a > 1
                    ? ("string" == typeof N.get("current") &&
                        L.html(
                          N.get("current")
                            .replace("{current}", F + 1)
                            .replace("{total}", a),
                        ).show(),
                      M[N.get("loop") || a - 1 > F ? "show" : "hide"]().html(
                        N.get("next"),
                      ),
                      H[N.get("loop") || F ? "show" : "hide"]().html(
                        N.get("previous"),
                      ),
                      ce(),
                      N.get("preloading") &&
                        e.each([r(-1), r(1)], function () {
                          var i = x[this],
                            o = new s(i, e.data(i, Z)),
                            n = o.get("href");
                          n &&
                            l(o, n) &&
                            ((n = d(o, n)), (t.createElement("img").src = n));
                        }))
                    : I.hide(),
                  N.get("iframe")
                    ? ((o = N.get("createIframe")),
                      N.get("scrolling") || (o.scrolling = "no"),
                      e(o)
                        .attr({ src: N.get("href"), class: G + "Iframe" })
                        .one("load", n)
                        .appendTo($),
                      re.one(se, function () {
                        o.src = "//about:blank";
                      }),
                      N.get("fastIframe") && e(o).trigger("load"))
                    : n(),
                  "fade" === N.get("transition") ? y.fadeTo(c, 1, i) : i());
              }),
              "fade" === N.get("transition")
                ? y.fadeTo(c, 0, function () {
                    V.position(0, n);
                  })
                : V.position(c, n);
          }
        }),
        (V.next = function () {
          !U && x[1] && (N.get("loop") || x[F + 1]) && ((F = r(1)), h(x[F]));
        }),
        (V.prev = function () {
          !U && x[1] && (N.get("loop") || F) && ((F = r(-1)), h(x[F]));
        }),
        (V.close = function () {
          B &&
            !X &&
            ((X = !0),
            (B = !1),
            p(oe),
            N.get("onCleanup"),
            C.unbind("." + G),
            m.fadeTo(N.get("fadeOut") || 0, 0),
            y.stop().fadeTo(N.get("fadeOut") || 0, 0, function () {
              y.hide(),
                m.hide(),
                p(se),
                $.remove(),
                setTimeout(function () {
                  (X = !1), p(ne), N.get("onClosed");
                }, 1);
            }));
        }),
        (V.remove = function () {
          y &&
            (y.stop(),
            e[Z].close(),
            y.stop(!1, !0).remove(),
            m.remove(),
            (X = !1),
            (y = null),
            e("." + J)
              .removeData(Z)
              .removeClass(J),
            e(t)
              .unbind("click." + G)
              .unbind("keydown." + G));
        }),
        (V.element = function () {
          return e(N.el);
        }),
        (V.settings = K));
    })(jQuery, document, window),
    (function (e) {
      "use strict";
      function t() {}
      function i() {
        try {
          return document.activeElement;
        } catch (e) {}
      }
      function o(e, t) {
        for (var i = 0, o = e.length; o > i; i++) if (e[i] === t) return !0;
        return !1;
      }
      function n(e, t, i) {
        return e.addEventListener
          ? e.addEventListener(t, i, !1)
          : e.attachEvent
            ? e.attachEvent("on" + t, i)
            : void 0;
      }
      function s(e, t) {
        var i;
        e.createTextRange
          ? ((i = e.createTextRange()).move("character", t), i.select())
          : e.selectionStart && (e.focus(), e.setSelectionRange(t, t));
      }
      function r(e, t) {
        try {
          return (e.type = t), !0;
        } catch (e) {
          return !1;
        }
      }
      function a(e, t) {
        if (e && e.getAttribute(y)) t(e);
        else
          for (
            var i = e ? e.getElementsByTagName("input") : $,
              o = e ? e.getElementsByTagName("textarea") : A,
              n = i ? i.length : 0,
              s = n + (o ? o.length : 0),
              r = 0;
            s > r;
            r++
          )
            t(n > r ? i[r] : o[r - n]);
      }
      function l(e) {
        a(e, d);
      }
      function d(e, t) {
        var i = !!t && e.value !== t,
          o = e.value === e.getAttribute(y);
        if ((i || o) && "true" === e.getAttribute(w)) {
          e.removeAttribute(w),
            (e.value = e.value.replace(e.getAttribute(y), "")),
            (e.className = e.className.replace(m, ""));
          var n = e.getAttribute(T);
          parseInt(n, 10) >= 0 &&
            (e.setAttribute("maxLength", n), e.removeAttribute(T));
          var s = e.getAttribute(b);
          return s && (e.type = s), !0;
        }
        return !1;
      }
      function c(e) {
        var t = e.getAttribute(y);
        return (
          !("" !== e.value || !t) &&
          (e.setAttribute(w, "true"),
          (e.value = t),
          (e.className += " " + v),
          e.getAttribute(T) ||
            (e.setAttribute(T, e.maxLength), e.removeAttribute("maxLength")),
          e.getAttribute(b)
            ? (e.type = "text")
            : "password" === e.type &&
              r(e, "text") &&
              e.setAttribute(b, "password"),
          !0)
        );
      }
      function u(e) {
        var t = e.form;
        t &&
          "string" == typeof t &&
          ((t = document.getElementById(t)).getAttribute(k) ||
            (n(
              t,
              "submit",
              (function (e) {
                return function () {
                  l(e);
                };
              })(t),
            ),
            t.setAttribute(k, "true"))),
          n(
            e,
            "focus",
            (function (e) {
              return function () {
                E &&
                e.value === e.getAttribute(y) &&
                "true" === e.getAttribute(w)
                  ? s(e, 0)
                  : d(e);
              };
            })(e),
          ),
          n(
            e,
            "blur",
            (function (e) {
              return function () {
                c(e);
              };
            })(e),
          ),
          E &&
            (n(
              e,
              "keydown",
              (function (e) {
                return function (t) {
                  return (
                    (h = e.value),
                    "true" === e.getAttribute(w) &&
                    h === e.getAttribute(y) &&
                    o(g, t.keyCode)
                      ? (t.preventDefault && t.preventDefault(), !1)
                      : void 0
                  );
                };
              })(e),
            ),
            n(
              e,
              "keyup",
              (function (e) {
                return function () {
                  d(e, h), "" === e.value && (e.blur(), s(e, 0));
                };
              })(e),
            ),
            n(
              e,
              "click",
              (function (e) {
                return function () {
                  e === i() &&
                    e.value === e.getAttribute(y) &&
                    "true" === e.getAttribute(w) &&
                    s(e, 0);
                };
              })(e),
            )),
          e.setAttribute(S, "true"),
          e.setAttribute(y, M),
          (E || e !== i()) && c(e);
      }
      var p = void 0 !== document.createElement("input").placeholder;
      if (
        ((e.Placeholders = {
          nativeSupport: p,
          disable: p ? t : l,
          enable: p
            ? t
            : function (e) {
                a(e, c);
              },
        }),
        !p)
      ) {
        var h,
          f = [
            "text",
            "search",
            "url",
            "tel",
            "email",
            "password",
            "number",
            "textarea",
          ],
          g = [27, 33, 34, 35, 36, 37, 38, 39, 40, 8, 46],
          v = "placeholdersjs",
          m = new RegExp("(?:^|\\s)" + v + "(?!\\S)"),
          y = "data-placeholder-value",
          w = "data-placeholder-active",
          b = "data-placeholder-type",
          k = "data-placeholder-submit",
          S = "data-placeholder-bound",
          T = "data-placeholder-maxlength",
          z = document.getElementsByTagName("head")[0],
          x = document.documentElement,
          C = e.Placeholders,
          $ = document.getElementsByTagName("input"),
          A = document.getElementsByTagName("textarea"),
          E = "false" === x.getAttribute("data-placeholder-focus"),
          P = "false" !== x.getAttribute("data-placeholder-live"),
          L = document.createElement("style");
        L.type = "text/css";
        var O = document.createTextNode("." + v + " {color:#ccc;}");
        L.styleSheet ? (L.styleSheet.cssText = O.nodeValue) : L.appendChild(O),
          z.insertBefore(L, z.firstChild);
        for (var M, H, j = 0, I = $.length + A.length; I > j; j++)
          (H = j < $.length ? $[j] : A[j - $.length]),
            (M = H.attributes.placeholder) &&
              (M = M.nodeValue) &&
              o(f, H.type) &&
              u(H);
        var N = setInterval(function () {
          for (var e = 0, t = $.length + A.length; t > e; e++)
            (H = e < $.length ? $[e] : A[e - $.length]),
              (M = H.attributes.placeholder)
                ? (M = M.nodeValue) &&
                  o(f, H.type) &&
                  (H.getAttribute(S) || u(H),
                  (M !== H.getAttribute(y) ||
                    ("password" === H.type && !H.getAttribute(b))) &&
                    ("password" === H.type &&
                      !H.getAttribute(b) &&
                      r(H, "text") &&
                      H.setAttribute(b, "password"),
                    H.value === H.getAttribute(y) && (H.value = M),
                    H.setAttribute(y, M)))
                : H.getAttribute(w) && (d(H), H.removeAttribute(y));
          P || clearInterval(N);
        }, 100);
        n(e, "beforeunload", function () {
          C.disable();
        });
      }
    })(this),
    (function (e, t) {
      "use strict";
      var i = e.fn.val,
        o = e.fn.prop;
      t.Placeholders.nativeSupport ||
        ((e.fn.val = function (e) {
          var t = i.apply(this, arguments),
            o = this.eq(0).data("placeholder-value");
          return void 0 === e &&
            this.eq(0).data("placeholder-active") &&
            t === o
            ? ""
            : t;
        }),
        (e.fn.prop = function (e, t) {
          return void 0 === t &&
            this.eq(0).data("placeholder-active") &&
            "value" === e
            ? ""
            : o.apply(this, arguments);
        }));
    })(jQuery, this),
    (function (e) {
      var t = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1,
      };
      (e.zoom = function (t, i, o, n) {
        var s,
          r,
          a,
          l,
          d,
          c,
          u,
          p = e(t),
          h = p.css("position"),
          f = e(i);
        return (
          (t.style.position = /(absolute|fixed)/.test(h) ? h : "relative"),
          (t.style.overflow = "hidden"),
          (o.style.width = o.style.height = ""),
          e(o)
            .addClass("zoomImg")
            .css({
              position: "absolute",
              top: 0,
              left: 0,
              opacity: 0,
              width: o.width * n,
              height: o.height * n,
              border: "none",
              maxWidth: "none",
              maxHeight: "none",
            })
            .appendTo(t),
          {
            init: function () {
              (r = p.outerWidth()),
                (s = p.outerHeight()),
                i === t
                  ? ((l = r), (a = s))
                  : ((l = f.outerWidth()), (a = f.outerHeight())),
                (d = (o.width - r) / l),
                (c = (o.height - s) / a),
                (u = f.offset());
            },
            move: function (e) {
              var t = e.pageX - u.left,
                i = e.pageY - u.top;
              (i = Math.max(Math.min(i, a), 0)),
                (t = Math.max(Math.min(t, l), 0)),
                (o.style.left = t * -d + "px"),
                (o.style.top = i * -c + "px");
            },
          }
        );
      }),
        (e.fn.zoom = function (i) {
          return this.each(function () {
            var o = e.extend({}, t, i || {}),
              n = (o.target && e(o.target)[0]) || this,
              s = this,
              r = e(s),
              a = document.createElement("img"),
              l = e(a),
              d = "mousemove.zoom",
              c = !1,
              u = !1;
            if (!o.url) {
              var p = s.querySelector("img");
              if (
                (p &&
                  (o.url = p.getAttribute("data-src") || p.currentSrc || p.src),
                !o.url)
              )
                return;
            }
            r.one(
              "zoom.destroy",
              function (e, t) {
                r.off(".zoom"),
                  (n.style.position = e),
                  (n.style.overflow = t),
                  (a.onload = null),
                  l.remove();
              }.bind(this, n.style.position, n.style.overflow),
            ),
              (a.onload = function () {
                function t(t) {
                  p.init(),
                    p.move(t),
                    l
                      .stop()
                      .fadeTo(
                        e.support.opacity ? o.duration : 0,
                        1,
                        !!e.isFunction(o.onZoomIn) && o.onZoomIn.call(a),
                      );
                }
                function i() {
                  l.stop().fadeTo(
                    o.duration,
                    0,
                    !!e.isFunction(o.onZoomOut) && o.onZoomOut.call(a),
                  );
                }
                var p = e.zoom(n, s, a, o.magnify);
                "grab" === o.on
                  ? r.on("mousedown.zoom", function (o) {
                      1 === o.which &&
                        (e(document).one("mouseup.zoom", function () {
                          i(), e(document).off(d, p.move);
                        }),
                        t(o),
                        e(document).on(d, p.move),
                        o.preventDefault());
                    })
                  : "click" === o.on
                    ? r.on("click.zoom", function (o) {
                        return c
                          ? void 0
                          : ((c = !0),
                            t(o),
                            e(document).on(d, p.move),
                            e(document).one("click.zoom", function () {
                              i(), (c = !1), e(document).off(d, p.move);
                            }),
                            !1);
                      })
                    : "toggle" === o.on
                      ? r.on("click.zoom", function (e) {
                          c ? i() : t(e), (c = !c);
                        })
                      : "mouseover" === o.on &&
                        (p.init(),
                        r
                          .on("mouseenter.zoom", t)
                          .on("mouseleave.zoom", i)
                          .on(d, p.move)),
                  o.touch &&
                    r
                      .on("touchstart.zoom", function (e) {
                        e.preventDefault(),
                          u
                            ? ((u = !1), i())
                            : ((u = !0),
                              t(
                                e.originalEvent.touches[0] ||
                                  e.originalEvent.changedTouches[0],
                              ));
                      })
                      .on("touchmove.zoom", function (e) {
                        e.preventDefault(),
                          p.move(
                            e.originalEvent.touches[0] ||
                              e.originalEvent.changedTouches[0],
                          );
                      })
                      .on("touchend.zoom", function (e) {
                        e.preventDefault(), u && ((u = !1), i());
                      }),
                  e.isFunction(o.callback) && o.callback.call(a);
              }),
              (a.src = o.url);
          });
        }),
        (e.fn.zoom.defaults = t);
    })(window.jQuery),
    (function (e) {
      var t,
        i,
        o = e.event;
      t = o.special.debouncedresize = {
        setup: function () {
          e(this).on("resize", t.handler);
        },
        teardown: function () {
          e(this).off("resize", t.handler);
        },
        handler: function (e, n) {
          var s = this,
            r = arguments,
            a = function () {
              (e.type = "debouncedresize"), o.dispatch.apply(s, r);
            };
          i && clearTimeout(i), n ? a() : (i = setTimeout(a, t.threshold));
        },
        threshold: 150,
      };
    })(jQuery),
    (e.fn.clickyBoxes = function (t) {
      return e(this)
        .filter("select:not(.replaced)")
        .addClass("replaced")
        .each(function () {
          var t,
            i = i || e(this).attr("id"),
            o = e('<ul class="clickyboxes"/>')
              .attr("id", "clickyboxes-" + i)
              .data("select", e(this))
              .insertAfter(this);
          (t = e(this).is("[id]")
            ? e('label[for="' + e(this).attr("id") + '"]')
            : e(this).siblings("label")).length > 0 &&
            o.addClass(
              "options-" +
                t
                  .html()
                  .toLowerCase()
                  .replace(/[^a-z0-9]/, "-"),
            ),
            e(this)
              .find("option")
              .each(function () {
                e("<li/>")
                  .appendTo(o)
                  .append(
                    e('<a href="#"/>')
                      .attr("data-value", e(this).val())
                      .html(e(this).html())
                      .addClass(
                        "opt-" +
                          e(this)
                            .text()
                            .toLowerCase()
                            .replace(/[^a-z0-9]*/g, "-")
                            .replace(/-+/g, "-")
                            .replace(/-*$/, ""),
                      ),
                  );
              }),
            e(this)
              .hide()
              .addClass("replaced")
              .on("change keyup", function () {
                o.find("a")
                  .removeClass("active")
                  .filter('[data-value="' + e(this).val() + '"]')
                  .addClass("active");
              })
              .trigger("keyup"),
            o.on("click", "a", function () {
              return (
                e(this).hasClass("active") ||
                  e(this)
                    .closest(".clickyboxes")
                    .data("select")
                    .val(e(this).data("value"))
                    .trigger("change"),
                !1
              );
            });
        });
    });
  (e.fn.selectReplace = function (t) {
    return e(this)
      .filter("select:not(.replaced, .noreplace)")
      .addClass("replaced")
      .each(function () {
        var t = e(this).find("option"),
          i =
            t.filter(":selected").length > 0
              ? t.filter(":selected").text()
              : t.first().text();
        e(this)
          .wrap('<div class="pretty-select">')
          .parent()
          .addClass("id-" + e(this).attr("id"))
          .append(
            '<span class="text"><span class="value">' +
              i +
              '</span></span><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
          )
          .toggleClass("plaintext", e(this).hasClass("plaintext"));
      })
      .on("change keyup", function () {
        e(this)
          .siblings(".text")
          .find(".value")
          .html(e(this).find(":selected").html());
      });
  }),
    (e.fn.cropImageToRatio = function (t) {
      t = e.extend({ ratio: 4 / 3 }, t);
      return e(this).each(function () {
        if (void 0 === e(this).data("imgratio")) {
          var i = e(this).width() / e(this).height(),
            o = t.ratio;
          e(this).data("imgratio", i),
            e(this)
              .css({
                position: "absolute",
                maxWidth: "none",
                maxHeight: "none",
              })
              .wrap("<div/>")
              .parent()
              .css({
                height: 0,
                paddingTop: 100 / t.ratio + "%",
                overflow: "hidden",
                position: "relative",
              }),
            i < o
              ? e(this).css({
                  top: 100 * -(o / (2 * i) - 0.5) + "%",
                  left: 0,
                  width: "100%",
                  height: "auto",
                })
              : e(this).css({
                  top: 0,
                  left: 100 * -(i / (2 * o) - 0.5) + "%",
                  width: "auto",
                  height: "100%",
                });
        }
      });
    }),
    (e.fn.staggerEvent = function (t, i, o) {
      (t = t), (i = i);
      var n = e(this);
      return (
        void 0 === o && (o = 0),
        setTimeout(function () {
          n.each(function (o) {
            var n = e(this);
            setTimeout(function () {
              "function" == typeof t ? t(n) : n.trigger(t);
            }, i * o);
          });
        }, o),
        e(this)
      );
    });
})(theme.jQuery);
